(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".SelectroV2 {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  --Selectro__item-gap: 0.7ch;\n  --Selectro__arrow-width: var(--spacer-3);\n  --Selectro__item-padding--vertical: 6px;\n  --Selectro__item-padding--horizontal: var(--spacer-2);\n  --Selectro__arrow-color--hover: var(--theme-inverted-primary-text);\n  --Selectro__input-height: 24px;\n  --Selectro__item-depth-unit: var(--spacer-2);\n  --Selectro--left-offset: 0.5;\n  --Selectro-item-margin-top: 10px;\n}\n.SelectroV2,\n.SelectroV2 * {\n  box-sizing: border-box;\n}\n\n.SelectroV2__body {\n  --min-height: 30px;\n  height: var(--min-height);\n  min-height: var(--min-height);\n  flex: 1 1 var(--min-height);\n  display: flex;\n  flex-direction: column;\n  line-height: var(--default-line-height);\n}\n\n.SelectroV2__list {\n  flex: 1 1 var(--min-height);\n  height: var(--min-height);\n  min-height: var(--min-height);\n  overflow-x: hidden;\n}\n.SelectroV2__list > *[style*='sticky'] {\n  z-index: 1;\n}\n\n.SelectroV2__list-item {\n  display: flex;\n  flex-wrap: wrap;\n}\n.SelectroV2__list-item > *:first-child {\n  flex: 1 1;\n}\n\n/*Manual overwrite to fix a react-virtuoso issue not removing the sticky container*/\n.SelectroV2__list > *[style*='sticky'].SelectroV2__non_sticky {\n  position: absolute !important;\n}\n\n.SelectroV2__item {\n  --Selectro__item--left-padding: calc(\n    var(--Selectro__item-padding--horizontal) +\n      (var(--Selectro__item--depth) * var(--Selectro__item-depth-unit))\n  );\n  display: flex;\n  align-items: start;\n  white-space: pre-line;\n  padding: var(--Selectro__item-padding--vertical)\n    var(--Selectro__item-padding--horizontal);\n  padding-left: var(\n    --Selectro__item--left-padding,\n    calc(var(--Selectro__item-depth-unit) / 2)\n  );\n  position: relative;\n}\n.SelectroV2__item > * {\n  min-width: var(--Selectro__item-depth-unit);\n}\n\n.SelectroV2__item--is-branch {\n  font-weight: bolder;\n}\n.SelectroV2__item--is-branch.SelectroV2__item--is-top-level:not(.SelectroV2__item--is-from-selected-list) {\n  margin-top: var(--Selectro-item-margin-top);\n}\n.SelectroV2__item--is-branch.SelectroV2__item--is-top-level.SelectroV2__item--is-from-selected-list {\n  padding-top: var(--Selectro-item-margin-top);\n}\n.SelectroV2__item--is-selected {\n  background-color: rgba(var(--rgb-blue-400), 0.1);\n}\n.SelectroV2__item:not([disabled]):not(.SelectroV2__item--is-not-selectable) {\n  cursor: pointer;\n}\n.SelectroV2__item[disabled],\n.SelectroV2__item--is-not-selectable {\n  cursor: not-allowed;\n}\n.SelectroV2__item[disabled] {\n  color: var(--theme-accent-text);\n}\n.SelectroV2__item--is-hovered[disabled],\n.SelectroV2__item--is-hovered.SelectroV2__item--is-not-selectable {\n  background-color: transparent;\n}\n.SelectroV2__item--is-clickable {\n  cursor: pointer;\n}\n.SelectroV2__item:focus-within {\n  background-color: var(--Color--focused);\n}\n.SelectroV2__item--centered {\n  align-items: center;\n}\n\n.SelectroV2__checkbox {\n  min-width: 11px;\n  display: inline-flex;\n  justify-content: center;\n  i {\n    font-weight: 900;\n    color: var(--theme-link-text);\n  }\n  input {\n    /*The input itself is pushed down just a bit. This shouldn't be overwritten by any other style, hence the !important.*/\n    /*This same style is applied to all checkboxes in aha-app. Adding this here as a fallback if something tries to overwrite it.*/\n    margin-top: 1px !important;\n  }\n}\n.SelectroV2__item-template {\n  flex: 1 1;\n  display: flex;\n  align-items: center;\n}\n\n.SelectroV2__item-template [tabindex] {\n    outline: none;\n}\n.SelectroV2__text {\n  flex: 1 1;\n}\n.SelectroV2__collapse-arrow + .SelectroV2__item-template,\n.SelectroV2__checkbox + .SelectroV2__item-template {\n  margin-left: var(--spacer-1);\n}\n\n.SelectroV2__item--create-new {\n  cursor: pointer;\n  padding-left: var(--Selectro__item-padding--horizontal);\n}\n\n.SelectroV2__item--create-new.SelectroV2__item--is-hovered {\n  color: var(--aha-blue-500);\n  text-decoration: underline;\n}\n\n.SelectroV2__item--no-results {\n  font-style: italic;\n  cursor: initial !important;\n}\n.SelectroV2__item mark {\n  border-bottom: thin solid var(--aha-blue-500);\n  color: var(--aha-blue-500);\n  background-color: transparent;\n}\n.SelectroV2__item--is-hovered:not(.SelectroV2__item--is-not-selectable):not(\n    [disabled]\n  ),\n.SelectroV2__list-prepend--is-hovered {\n  background-color: var(--theme-tertiary-background);\n}\n.SelectroV2__item--is-hovered.SelectroV2__item--is-selected:not([disabled]) {\n  background-color: rgba(var(--rgb-blue-400), 0.2);\n  color: var(--aha-blue-500);\n}\n\n.SelectroV2__item--warning {\n  background-color: var(--theme-error-message);\n  color: var(--theme-inverted-primary-text);\n}\n\n.SelectroV2__loading-more {\n  flex: 1 0 100%;\n  width: 100%;\n}\n.SelectroV2__loading-children {\n  flex: 1 1 100%;\n  width: 100%;\n}\n\n.SelectroV2__divider {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n.SelectroV2__divider hr {\n  margin: 0;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: var(--theme-light-border);\n}\n\n.SelectroV2__info-bar {\n  display: flex;\n  align-items: center;\n  background-color: var(--aha-gray-100);\n}\n.SelectroV2__info-bar:empty {\n  display: none;\n}\n\n.SelectroV2__dropdown__content-container[data-placement^='top'] .SelectroV2 {\n  flex-direction: column-reverse;\n}\n.SelectroV2__dropdown__content-container[data-placement^='top'] .SelectroV2__info-bar {\n  border-bottom: 1px solid var(--Common--border-color);\n  border-top-left-radius: var(--Common--border-radius);\n  border-top-right-radius: var(--Common--border-radius);\n}\n.SelectroV2__dropdown__content-container[data-placement^='bottom'] .SelectroV2__info-bar {\n  border-bottom-left-radius: var(--Common--border-radius);\n  border-bottom-right-radius: var(--Common--border-radius);\n  border-top: 1px solid var(--Common--border-color);\n}\n.SelectroV2__counter-number {\n  padding: 0.25em 0.5em;\n}\n.SelectroV2__counter-number > * {\n  line-height: 1;\n}\n.SelectroV2__counter-number--filtered {\n  margin-left: auto;\n}\n.SelectroV2__counter-number--selected {\n  cursor: pointer;\n}\n\n.SelectroV2__item:not(:first-child) .message {\n  border-top: 1px #ccc solid;\n}\n\n[class^='SelectroV2'],\n[class^='SelectroV2'] *,\n[class^='SelectroV2'] *:before,\n[class^='SelectroV2'] *:after {\n  box-sizing: border-box;\n}\n\n.SelectroV2__search {\n  display: flex;\n  position: relative;\n  z-index: 3;\n  background-color: var(--aha-blue-100);\n  border-radius: var(--Common--border-radius);\n}\n.SelectroV2__search:focus-within {\n  box-shadow: 0 0 2px 1px var(--aha-blue-500);\n}\n.SelectroV2__search > * {\n  padding: 0 0.5em;\n  /* padding: 10px; */\n  /* line-height: 30px; */\n}\n.SelectroV2__search-input[type='text'] {\n  flex: 1 1;\n  background-color: transparent;\n  border: none;\n  margin: 0;\n  height: var(--Selectro__input-height);\n  line-height: var(--Selectro__input-height);\n  width: 100% !important;\n  padding: 0 0.5em;\n  font-size: inherit;\n  font-family: inherit;\n  outline: none;\n}\n.SelectroV2__search-input[type='text']::placeholder {\n  color: var(--aha-blue-400);\n}\n.SelectroV2__search-input[type='text']::selection {\n  background: var(--aha-blue-400);\n  color: var(--theme-inverted-primary-text);\n}\n.SelectroV2__search-input[type='text'],\n.SelectroV2__search-input[type='text']:focus,\n.SelectroV2__search-input[type='text']:hover,\n.SelectroV2__search-input[type='text']:active {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n  border-radius: inherit;\n}\n.SelectroV2__dropdown__content-container[data-placement^='bottom'] .SelectroV2__search {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.SelectroV2__dropdown__content-container[data-placement^='top'] .SelectroV2__search {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.SelectroV2__search-input:focus {\n  outline: none;\n}\n\n.SelectroV2__action-bar {\n  display: flex;\n  background: var(--theme-primary-background);\n  border-bottom: 1px solid var(--theme-light-border);\n}\n\n.SelectroV2__action-bar-vertical {\n  flex-direction: column;\n}\n\n.SelectroV2__action-bar > * {\n  display: flex;\n}\n.SelectroV2__action-bar-child {\n  color: var(--theme-link-text);\n}\n.SelectroV2__action-bar-child--is-hovered {\n  color: var(--aha-blue-500);\n  text-decoration: underline;\n}\n/*Theres a CSS rule that sets the display to flex of all the contents\nof the action-bar-child [.SelectroV2__action-bar > * > *]\nThis reset causes issues when the child is an <a> with inline icons.\nSetting the display to block fixes this issue*/\n.SelectroV2__action-bar-child a {\n  display: block;\n}\n.SelectroV2__action-bar > * > * {\n  padding: var(--spacer-2) var(--Selectro__item-padding--horizontal);\n  display: flex;\n  flex: 1 1;\n}\n.SelectroV2__action-bar > *:first-child {\n  flex: 1 1;\n}\n.SelectroV2__clear-all {\n  background: none;\n  border: none;\n  text-shadow: none;\n  font: inherit;\n  cursor: pointer;\n  flex: 1 1 100%;\n  text-align: left;\n  color: inherit;\n  padding: var(--spacer-2)\n    var(--Selectro__item-padding--horizontal);\n}\n\n.SelectroV2__search_icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  color: var(--aha-blue-400);\n}\n\n.SelectroV2__clear-button {\n  border: none;\n  background: none;\n  padding-top: 0;\n  padding-bottom: 0;\n  cursor: pointer;\n  color: var(--aha-blue-400);\n}\n.SelectroV2__clear-button:not([disabled]):hover,\n.SelectroV2__clear-button:not([disabled]):focus {\n  outline: none;\n  color: var(--theme-error-message);\n}\n.SelectroV2__fetch-error {\n  color: var(--theme-error-message);\n}\n\n.SelectroV2__clear-button > * {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.SelectroV2__collapse-arrow {\n  padding: 0;\n  border: none;\n  background: transparent;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  width: var(--Selectro__item-depth-unit);\n  font-size: var(--Selectro__arrow-width);\n  flex: 0 0 var(--Selectro__arrow-width);\n}\n.SelectroV2__item .arrow--right {\n  position: relative;\n  top: 1.2px;\n}\n\n.SelectroV2__fetch-error {\n  font-size: x-small;\n  font-style: italic;\n  color: var(--theme-error-message);\n}\n\n.SelectroV2__spinner {\n  --aha-spinner--size: 1.2ch;\n  --aha-spinner--stroke: calc(var(--aha-spinner--size) * 0.2);\n  --aha-spinner--opacity: 1;\n}\n.SelectroV2__spinner[paused] {\n  --aha-spinner--color: var(--theme-error-message);\n  --aha-spinner--border-color: var(--aha-spinner--color)\n    var(--aha-spinner--color) var(--aha-spinner--color)\n    var(--aha-spinner--color);\n  --aha-spinner--border-radius: 0;\n  --aha-spinner--background-color: var(--theme-error-message);\n  margin-left: calc(var(--Selectro__item-gap) * 1.9) !important;\n}\n\n.SelectroV2__collapse-arrow:hover,\n.SelectroV2__collapse-arrow:focus {\n  color: rgb(var(--Selectro__arrow-color--hover));\n}\n\n.SelectroV2__item--is-not-selectable .SelectroV2__collapse-arrow:hover,\n.SelectroV2__item--is-not-selectable .SelectroV2__collapse-arrow:focus {\n  --Selectro__arrow-color--hover: var(--Color-focused);\n}\n\n.SelectroV2__collapse-arrow.SelectroV2__collapse-arrow--disabled {\n  opacity: 0.15;\n  box-shadow: none;\n}\n.SelectroV2__collapse-arrow fa-icon {\n  position: relative;\n  font-size: 14px;\n}\n.SelectroV2__collapse-space {\n  width: var(--Selectro__arrow-width);\n  flex: 0 0 var(--Selectro__arrow-width);\n  display: inline-block;\n}\n\n.SelectroV2__fetching-progress-bar {\n  position: relative;\n  z-index: 100;\n}\n.SelectroV2__fetching-progress-bar div {\n  --height: 2px;\n  position: absolute;\n  width: 100%;\n  height: var(--height);\n  overflow: hidden;\n  top: 0;\n  left: 0;\n}\n.SelectroV2__fetching-progress-bar div::before {\n  content: '';\n  width: 50%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: var(--height);\n  background: rgba(var(--rgb-blue-500), 0.8);\n  animation-name: animation-fetching-progress-bar;\n  animation-delay: 0;\n  animation-iteration-count: infinite;\n  animation-duration: 0.6s;\n  animation-timing-function: linear;\n}\n\n.SelectroV2__dropdown__content-container .SelectroV2 {\n  max-width: 100%;\n}\n\n@keyframes animation-fetching-progress-bar {\n  0% {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(200%);\n  }\n}\n\n.SelectroV2__dropdown {\n  &.SelectroV2__dropdown--full-width {\n    .selectro-trigger {\n      width: 100%;\n      max-width: 100%;\n    }\n    width: 100%;\n  }\n  &.SelectroV2__dropdown--disabled {\n    pointer-events: none;\n    cursor: not-allowed;\n\n    .selectro-trigger {\n      background-color: var(--theme-tertiary-background);\n    }\n    a {\n      pointer-events: all;\n    }\n  }\n}\n\n.SelectroV2__dropdown__popover {\n  outline: none;\n  background: none;\n  border: none;\n}\n\n.SelectroV2__dropdown__content-container {\n  /*\n  The min width of the dropdown can be customize with this variable or using the matchTriggerWidth prop\n  */\n  --Selectro-v2__dropdown--min-width: 350px;\n\n  min-width: var(--Selectro-v2__dropdown--min-width);\n  min-height: 24px;\n  max-height: 50vh;\n  width: 100%;\n  background: var(--theme-primary-background);\n  box-shadow: var(--theme-shadow-deep);\n  font-size: var(--default-font-size);\n  position: fixed;\n  border-radius: var(--Common--border-radius);\n  border: var(--Common--border);\n  box-sizing: content-box;\n}\n\n/*Quick way to make the trigger full-width*/\n.SelectroV2--full-width-trigger {\n  .selectro-trigger {\n    width: 100%;\n  }\n}\n\n/*Add ellipsis to default selectro-trigger*/\n.SelectroV2__dropdown__trigger-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacer-1);\n  .selectro-trigger.default {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    outline: none;\n    min-height: 30px;\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.SelectroV2__dropdown__trigger--content {\n  display: flex;\n  align-items: center;\n  gap: var(--spacer-1);\n}\n\n.SelectroV2__none_selected_text {\n  color: var(--theme-tertiary-text);\n  &.SelectroV2__none_selected_text--primary-text {\n    color: var(--theme-primary-text);\n  }\n}\n\n.SelectroV2__first-item {\n  margin-top: var(--Selectro-item-margin-top);\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React, { useState, useCallback, useEffect, useRef } from "react";
import ApplicationController, { observable, ApplicationView, useController, raw, StartControllerScope } from "@aha-app/mvc";
import escapeRegex from "escape-string-regexp";
import FlexSearch from "flexsearch";
import cloneDeep from "lodash.clonedeep";
import debounce from "lodash.debounce";
import queue from "queue";
import "requestidlecallback-polyfill";
import bigInt from "big-integer";
import { nanoid } from "nanoid";
import classcat from "classcat";
import * as Sentry from "@sentry/browser";
import { captureException } from "@sentry/browser";
import fetchRetry from "fetch-retry";
import _ from "lodash";
import restrictScroll from "restrict-scroll";
import { useFloating, autoPlacement, offset, size, autoUpdate } from "@floating-ui/react-dom";
import { preventNextKey } from "@aha-app/aha-shared";
import renderIf from "render-if";
import { Virtuoso } from "react-virtuoso";
function i18nNumber(number, language = "en-US") {
  return new Intl.NumberFormat(language).format(number);
}
const resolveWindowAttachedFunction = (functionName, parent) => {
  const keys = functionName.split(".");
  return keys.reduce((acc, key) => acc[key], window[parent]);
};
function getCallback(callback2) {
  if (!callback2) return null;
  const type = typeof callback2;
  switch (type) {
    case "string":
      return resolveWindowAttachedFunction(callback2, "Callbacks");
    case "function":
      return callback2;
    default:
      return null;
  }
}
function toArray(value) {
  if (!value) return [];
  if (value.toArray) {
    return value.toArray();
  } else if (Array.isArray(value)) {
    return value;
  } else {
    const arr = Array.from(value);
    if (value && !arr.length) arr.push(value);
    return arr;
  }
}
function normalizeValue(value) {
  if (/^\d+$/.test(value)) {
    return bigInt(value).toString();
  } else if (typeof value === "string") {
    return value;
  } else if (value === null) {
    return "";
  } else {
    return `__AUTO_ID__${performance.now()}`;
  }
}
window.selectro = {
  debug: false,
  env: process.env.NODE_ENV
};
function measurePerformance({ name, group = false }) {
  if (window.selectro.debug) {
    console.time(name);
    if (group) console.group(name);
  }
  return () => {
    if (window.selectro.debug) {
      console.timeEnd(name);
      if (group) console.groupEnd(name);
    }
  };
}
function Middleware(type, obj, opts = {}) {
  Object.defineProperties(obj, {
    type: {
      value: type,
      configurable: false,
      enumerable: false
    },
    _prepend: {
      value: opts.prepend || [],
      configurable: false,
      enumerable: false
    },
    _postpend: {
      value: opts.postpend || [],
      configurable: false,
      enumerable: false
    }
  });
  return obj;
}
const clearBreakMiddlewares = (controller) => {
  controller.actionSetBreakMiddlewares(false);
};
function executeMiddleware({
  fn,
  idx,
  controller,
  payload,
  baseName = ""
}) {
  const measureFnPerformance = measurePerformance({
    name: `[${[baseName, idx].join(" ").trim()}] ${fn.name}`
  });
  fn(controller, payload);
  measureFnPerformance();
}
function runMiddlewares(middlewareObject, controller, payload) {
  if (!middlewareObject) return;
  const name = `⏱ Middleware: ${middlewareObject.type}`;
  const middlewares = middlewareObject[controller.state.type];
  if (!middlewares) {
    console.error(
      new Error(
        `No middlewares matching type of ${middlewareObject.type}:${controller.state.type} were found.`
      )
    );
    return;
  }
  const measureEntirePerformance = measurePerformance({ name, group: true });
  middlewareObject._prepend.forEach((fn, idx) => {
    executeMiddleware({ fn, idx, controller, payload, baseName: "PRE" });
  });
  for (let idx = 0, len = middlewares.length; idx < len; idx++) {
    if (controller.state.breakMiddlewares) break;
    const fn = middlewares[idx];
    executeMiddleware({ fn, idx, controller, payload, baseName: "ACTION" });
  }
  middlewareObject._postpend.forEach((fn, idx) => {
    executeMiddleware({ fn, idx, controller, payload, baseName: "POST" });
  });
  measureEntirePerformance();
  clearBreakMiddlewares(controller);
}
const toggleItem = (_draft, { item }) => {
  if (!item.selected || item.selected === -1) {
    item.selected = 1;
  } else {
    item.selected = 0;
  }
};
const selectExclusiveItem = (draft, { item, forceTrue = true }) => {
  const selectedStateKeys = draft.state.selectedState.keys();
  const selectedValue = selectedStateKeys.next().value;
  if (selectedValue && draft.items.findIndex(({ value }) => selectedValue === value) < 0) {
    draft.actionDeleteFromSelectedState(selectedValue);
  }
  item.selected = forceTrue ? 1 : item.selected ? 0 : 1;
  draft.items.forEach((i) => {
    if (i.data.value !== item.data.value) i.selected = 0;
  });
};
const toggleExclusiveItem = (draft, { item }) => {
  selectExclusiveItem(draft, { item, forceTrue: false });
};
const indeterminateAllParents = (_draft, { item }) => {
  item.parents.forEach((parent) => {
    const children = parent.descendants;
    const childSelections = children.reduce((acc, child) => {
      if (child.isSelected) acc.push(child.selected);
      return acc;
    }, []);
    if (parent.isSelectable && children.length === childSelections.length) {
      parent.selected = 1;
    } else if (childSelections.length) {
      parent.selected = -1;
    } else {
      parent.selected = 0;
    }
  });
};
const selectAllParents = (_draft, { item }) => {
  if (item.isSelected) {
    item.parents.forEach((parent) => {
      if (parent.isSelectable) parent.selected = 1;
    });
  }
};
const deselectAllParentsIfNoChildSelected = (_draft, { item }) => {
  if (!item.selected) {
    item.parents.forEach((parent) => {
      const someChildrenSelected = parent.descendants.filter(
        (child) => child.isSelected
      );
      if (!someChildrenSelected.length) {
        parent.selected = 0;
      }
    });
  }
};
const selectAllDescendants = (draft, { item: selectedItem }) => {
  if (selectedItem.isSelected && selectedItem.branch) {
    const idx = draft.items.indexOf(selectedItem);
    for (let i = idx + 1, len = draft.items.length; i < len; i++) {
      const item = draft.items[i];
      if (item.depth <= selectedItem.depth) break;
      if (item.isSelectable) item.selected = selectedItem.selected;
    }
  }
};
const deselectAllDescendants = (draft, { item: selectedItem }) => {
  if (!selectedItem.selected && selectedItem.branch) {
    const idx = draft.items.indexOf(selectedItem);
    for (let i = idx + 1, len = draft.items.length; i < len; i++) {
      const item = draft.items[i];
      if (item.depth <= selectedItem.depth) break;
      item.selected = 0;
    }
  }
};
const toggleAllDescendants = (draft, { item }) => {
  if (!item.branch) return;
  item.isSelected ? selectAllDescendants(draft, { item }) : deselectAllDescendants(draft, { item });
};
const selectAllDescendantsWithoutParent = (draft, { item: targetItem }) => {
  const forceSelectLeafDescendants = (item) => {
    if (!item.branch) {
      item.selected = 1;
      return;
    }
    item.descendants.filter((d) => d.parent === item).forEach((child) => {
      if (child.isSelectable) {
        forceSelectLeafDescendants(child);
      }
    });
  };
  if (!targetItem.branch) {
    toggleItem(draft, { item: targetItem });
    return;
  }
  targetItem.descendants.filter((d) => d.parent === targetItem).forEach((child) => {
    if (child.isSelectable) {
      forceSelectLeafDescendants(child);
    }
  });
};
const callback$2 = (draft, payload) => {
  const callbackFn = getCallback(
    draft.state.callbacks.select
  );
  if (callbackFn) {
    callbackFn({
      state: draft.state,
      payload,
      selected: draft.selected,
      controller: draft
    });
  }
};
const capturePreviousState = (draft) => {
  draft.state.previousState.selected = Array.from(
    draft.state.selectedState.values()
  ).map((entry) => entry.item);
};
const clearPreviousState = (draft) => {
  draft.state.previousState = {};
};
const breakIfNotSelectable = (draft, { item }) => {
  if (!item.isSelectable) {
    draft.actionSetBreakMiddlewares(true);
  }
};
const setRecent = (draft, { item }) => {
  if (!draft.recentsController) {
    return;
  }
  draft.recentsController.setRecentItem(item.value);
};
const selectMiddlewares = Middleware(
  "select",
  {
    single: [selectExclusiveItem, setRecent],
    toggleSingle: [toggleExclusiveItem],
    multiple: [toggleItem],
    tree: [toggleItem, toggleAllDescendants, indeterminateAllParents],
    treeSingle: [selectExclusiveItem, setRecent],
    treeToggleSingle: [toggleExclusiveItem],
    selectingChildSelectsParents: [toggleItem, selectAllParents],
    deselectingChildDeselectsParents: [
      toggleItem,
      deselectAllParentsIfNoChildSelected
    ],
    selectingParentTogglesChildren: [toggleItem, toggleAllDescendants],
    selectingParentSelectsChildrenOnly: [selectAllDescendantsWithoutParent]
  },
  {
    // Define actions that will be run before/after the main actions.
    prepend: [breakIfNotSelectable, capturePreviousState],
    postpend: [callback$2, clearPreviousState]
  }
);
const toggleCollapsible = (draft, { item: toggledItem, inSelectedList, collapse }) => {
  let minDepth;
  const collapsedKey = inSelectedList ? "collapsedSelected" : "collapsed";
  const hiddenByKey = inSelectedList ? "hiddenBySelected" : "hiddenBy";
  const isCollapsed = toggledItem[collapsedKey];
  const newCollapsedState = collapse == null ? !isCollapsed : collapse;
  if (collapse === isCollapsed) return;
  draft.items.forEach((item) => {
    const itemDepth = item.depth;
    const itemHiddenBy = item[hiddenByKey];
    if (item === toggledItem) {
      minDepth = itemDepth;
      item[collapsedKey] = newCollapsedState;
    } else {
      if (minDepth == null) return;
      if (itemDepth <= minDepth) {
        minDepth = void 0;
      } else {
        if (itemHiddenBy == null) {
          item[hiddenByKey] = toggledItem;
        } else if (itemHiddenBy === toggledItem) {
          item[hiddenByKey] = toggledItem[hiddenByKey];
        } else ;
      }
    }
  });
};
const redrawSelectedList$1 = (draft, { inSelectedList }) => {
  if (inSelectedList) draft.redrawSelectedList();
};
const callback$1 = (draft, payload) => {
  const _callbackFn = getCallback(
    draft.state.callbacks.collapse
  );
  if (_callbackFn) {
    _callbackFn({ state: draft.state, payload, controller: draft });
  }
};
const setCollapsibleStorage = (draft, { item: collapsedItem, inSelectedList, collapse }) => {
  var _a;
  if (inSelectedList) return;
  (_a = draft.collapsibleStorageController) == null ? void 0 : _a.setCollapsed(
    collapsedItem.value,
    collapse
  );
};
const defaultCollapseMiddlewares = [
  toggleCollapsible,
  redrawSelectedList$1,
  setCollapsibleStorage
];
const collapseMiddlewares = Middleware(
  "collapse",
  {
    single: defaultCollapseMiddlewares,
    toggleSingle: defaultCollapseMiddlewares,
    multiple: defaultCollapseMiddlewares,
    tree: defaultCollapseMiddlewares,
    treeSingle: defaultCollapseMiddlewares,
    treeToggleSingle: defaultCollapseMiddlewares,
    selectingChildSelectsParents: defaultCollapseMiddlewares,
    deselectingChildDeselectsParents: defaultCollapseMiddlewares,
    selectingParentTogglesChildren: defaultCollapseMiddlewares
  },
  // Define actions that will be run before/after the main actions.)
  {
    postpend: [callback$1]
  }
);
const breakIfNoSearchQuery = (draft) => {
  if (!draft.state.searchQuery) {
    draft.actionSetBreakMiddlewares(true);
    draft.actionSetSearchComplete(false);
  }
};
const clearItemsSearchMatch = (draft) => {
  draft.state.matchedState.clear();
  draft.searchIndex.matches = [];
};
const matchSearchQuery = async (draft) => {
  draft.searchIndex.matches = draft.searchIndex.search(
    draft.state.searchQuery,
    Infinity
  );
  draft.searchIndex.matches.forEach((value) => {
    const item = draft.itemsUUIDMap.get(value);
    if (item) item.searchMatch = 1;
  });
};
const pseudoMatchChildren = (draft) => {
  const resetDepth = Infinity;
  let minDepth = resetDepth;
  draft.items.forEach((item) => {
    const itemDepth = item.depth;
    if (item.searchMatch) {
      if (itemDepth < minDepth) minDepth = itemDepth;
    } else {
      if (item.branch && itemDepth <= minDepth) {
        minDepth = resetDepth;
      } else if (itemDepth > minDepth) {
        item.searchMatch = -1;
      }
    }
  });
};
const pseudoMatchParents = (draft) => {
  let maxDepth;
  for (let i = draft.items.length - 1; i >= 0; i--) {
    const item = draft.items[i];
    const itemDepth = item.depth;
    if (item.searchMatch) {
      maxDepth = itemDepth;
    } else {
      if (itemDepth < maxDepth) {
        item.searchMatch = -1;
        maxDepth = itemDepth;
      }
    }
  }
};
const scrollToFirstMatch = (draft) => {
  var _a;
  const actionBarOffset = ((_a = draft.state.actionBar) == null ? void 0 : _a.visible) ? 1 : 0;
  if (draft.searchIndex.matches.length) {
    const firstMatch = draft.mainList.findIndex((item) => item.isMatched);
    const selectedOffset = draft.selectedList.length ? draft.selectedList.length : 0;
    draft.setHoveredIndex({
      index: firstMatch + selectedOffset + actionBarOffset
    });
  } else if (draft.state.allowCreateNew) {
    draft.setHoveredIndex({
      index: 0 + actionBarOffset
    });
  }
};
const searchResultsReturned = (draft) => {
  draft.actionSetSearchComplete(!!draft.state.searchQuery);
};
const callback = (draft, payload) => {
  const callbackFn = getCallback(
    draft.state.callbacks.search
  );
  if (callbackFn) {
    callbackFn({ state: draft.state, payload, controller: draft });
  }
};
const defaultSearchMiddlewares = [
  clearItemsSearchMatch,
  breakIfNoSearchQuery,
  matchSearchQuery,
  pseudoMatchChildren,
  pseudoMatchParents,
  searchResultsReturned,
  scrollToFirstMatch
];
const searchMiddlewares = Middleware(
  "search",
  {
    single: defaultSearchMiddlewares,
    toggleSingle: defaultSearchMiddlewares,
    multiple: defaultSearchMiddlewares,
    tree: defaultSearchMiddlewares,
    treeSingle: defaultSearchMiddlewares,
    treeToggleSingle: defaultSearchMiddlewares,
    selectingChildSelectsParents: defaultSearchMiddlewares,
    deselectingChildDeselectsParents: defaultSearchMiddlewares,
    selectingParentTogglesChildren: defaultSearchMiddlewares
  },
  { postpend: [callback] }
  // Define actions that will be run before/after the main actions.)
);
const selectChildrenWhenParentSelected = (draft) => {
  for (let i = 0, len = draft.items.length; i < len; i++) {
    const item = draft.items[i];
    if (item.isSelectable && item.parent && item.parent.isSelected) {
      item.selected = item.parent.selected;
    }
  }
};
const selectParentWhenChildrenSelected = (draft) => {
  const allBranches = /* @__PURE__ */ new Map();
  for (let i = draft.items.length - 1; i >= 0; i--) {
    const item = draft.items[i];
    const parent = item.parent;
    if (item.branch && !item.isSelected) {
      const itemValues = allBranches.get(item) || /* @__PURE__ */ new Set();
      if (itemValues.size > 1) {
        item.selected = -1;
      } else if (itemValues.size === 1) {
        const value = Array.from(itemValues)[0];
        if (item.selectable && draft.state.branchesSelectable) {
          item.selected = value;
        } else {
          item.selected = value ? -1 : 0;
        }
      }
      itemValues.add(item.selected);
      allBranches.set(item, itemValues);
    }
    if (parent && !parent.isSelected) {
      const parentValues = allBranches.get(parent) || /* @__PURE__ */ new Set();
      parentValues.add(item.selected);
      allBranches.set(parent, parentValues);
    }
  }
  allBranches.forEach((values, key) => {
    if (key.selectable) {
      if (values.size > 1) {
        key.selected = -1;
      } else if (values.size === 1) {
        const value = Array.from(values)[0];
        key.selected = value;
      } else {
        key.selected = 0;
      }
    }
  });
};
const redrawSelectedList = (draft) => {
  draft.redrawSelectedList();
};
const normalizeMiddlewares = Middleware("normalize", {
  single: [],
  toggleSingle: [],
  multiple: [],
  tree: [
    selectParentWhenChildrenSelected,
    selectChildrenWhenParentSelected,
    redrawSelectedList
  ],
  treeSingle: [],
  treeToggleSingle: [],
  selectingChildSelectsParents: [
    selectParentWhenChildrenSelected,
    redrawSelectedList
  ],
  deselectingChildDeselectsParents: [
    selectParentWhenChildrenSelected,
    redrawSelectedList
  ],
  selectingParentTogglesChildren: [
    selectChildrenWhenParentSelected,
    redrawSelectedList
  ]
});
let Item$2 = class Item {
  // Whether the item is an in-tree duplicate of another item. Disables search pseudo-matching.
  constructor(props) {
    __publicField(this, "data", { text: "", value: "" });
    __publicField(this, "meta", {});
    __publicField(this, "currentPage", 0);
    __publicField(this, "totalPages", 0);
    __publicField(this, "nextPage", 0);
    __publicField(this, "branch", false);
    __publicField(this, "depth", 0);
    __publicField(this, "type", "Item");
    // Internal state variables.
    __publicField(this, "updatesSearch", false);
    __publicField(this, "disabled", false);
    __publicField(this, "selectable", true);
    // When checking selectable state, should use `isSelectable` method below. This exists as a means to make a single item un-selectable.
    __publicField(this, "disableCollapse", false);
    // Whether an item with children can be collapsed or not.
    __publicField(this, "collapsed", false);
    // Whether the item is in a collapsed state in the "main" list (not selected list).
    __publicField(this, "collapsedSelected", false);
    // Whether the item is in a collapsed state in the "selected" list.
    __publicField(this, "hiddenBy");
    // The item in the "main" list that controlls the collapsed state of this item (ex. parent branch is collapsed).
    __publicField(this, "hiddenBySelected");
    // The item in the "selected" list that controlls the collapsed state of this item (ex. parent branch is collapsed).
    __publicField(this, "selectro");
    // Reference back to the parent list (SelectroStore object).
    __publicField(this, "fetchHandle");
    // Reference to FetchHandle object
    __publicField(this, "fetching", false);
    // Whether the item is currently fetching
    __publicField(this, "fetchError");
    // Any fetch error the fetchHandle may have encountered.
    __publicField(this, "persistent");
    // Stays present in the list, even if select/filter states would normally exclude it.
    __publicField(this, "parent");
    // Parent item of this item.
    __publicField(this, "uuid", "");
    __publicField(this, "local", false);
    // We create local items for the selectedState when using custom search, because the item could not be in the first page.
    __publicField(this, "virtual", false);
    this.uuid = nanoid();
    Object.assign(this, props);
    this.selectro = props.selectro;
    this.addToSearchIndex();
    return observable(this);
  }
  // Add item to the selectro's search index.
  addToSearchIndex() {
    if (this.state.searchFields) {
      const searchString = this.state.searchFields.map((field) => this.data[field]).filter(Boolean);
      this.selectro.searchIndex.add(this.uuid, searchString.join(" "));
    }
  }
  // Get all descendants of an item. Set max depth for how deep down you want to traverse.
  getDescendants(maxDepth = Infinity) {
    const nodes = [];
    let inChildren;
    for (let i = 0, len = this.selectro.items.length; i < len; i++) {
      const item = this.selectro.items[i];
      if (inChildren) {
        if (item.depth <= this.depth) break;
        if (item.depth <= maxDepth) nodes.push(item);
      }
      if (item === this) inChildren = true;
    }
    return nodes;
  }
  // Get all ancestors of an item.
  getAncestors() {
    let node = this;
    const nodes = [];
    while (node.parent) {
      node = node.parent;
      nodes.push(node);
    }
    return nodes;
  }
  // Because an item can have different collapse states depending on whether they are in the
  // selectedList or not, we need to pass an index before determing if the item is, in fact, collapsed.
  isCollapsed(index) {
    return this.fetchError ? true : this.inSelectedList(index) ? this.collapsedSelected : this.collapsed;
  }
  // Because the same item can exist at multiple different places within the list (eg, in the selected list
  // and in the main list), we need to pass an index before determing if the item is, in fact, in the selectedList.
  inSelectedList(index) {
    return index > -1 && index < this.selectro.selectedList.length;
  }
  // ============================= COMPUTED ============================= //
  get state() {
    return this.selectro.state;
  }
  // Get the item's value from the data node.
  get value() {
    var _a, _b;
    return (_b = (_a = this.data) == null ? void 0 : _a.value) == null ? void 0 : _b.toString();
  }
  // Get the item's text from the data node.
  get text() {
    return this.data.text;
  }
  get fetchUrl() {
    return this.data.fetchUrl;
  }
  set fetchUrl(value) {
    this.data.fetchUrl = value;
  }
  get selected() {
    const selectedItem = this.state.selectedState.get(this.value);
    if (!selectedItem) return 0;
    return selectedItem.status;
  }
  set selected(value) {
    if (Number.isNaN(value))
      throw new Error(
        "The selected value can only be a value of -1 (partially selected), 0 (not selected), or 1 (selected)."
      );
    if (value) {
      this.selectro.actionAddToSelectedState(this.value, {
        status: value,
        item: this
      });
    } else {
      this.selectro.actionDeleteFromSelectedState(this.value);
    }
  }
  get searchMatch() {
    const isAnyValueMatched = this.state.matchedState.get(this.value) || 0;
    if (isAnyValueMatched === 1) return 1;
    if (isAnyValueMatched === -1) return -1;
    return 0;
  }
  set searchMatch(value) {
    value ? this.state.matchedState.set(this.value, value) : this.state.matchedState.delete(this.value);
  }
  get isCompletelyFetched() {
    if (!this.canFetch) return true;
    if (this.fetching) return false;
    if (this.currentPage && this.totalPages && this.currentPage === this.totalPages)
      return true;
    return false;
  }
  get canFetch() {
    return !!this.fetchUrl;
  }
  get isFetchable() {
    return !this.fetching && !this.isCompletelyFetched;
  }
  get isSelectable() {
    if (this.branch) {
      return typeof this.state.branchesSelectable !== "undefined" ? this.state.branchesSelectable && this.selectable : this.selectable;
    } else {
      return this.selectable;
    }
  }
  get isSelected() {
    return this.selected === 1;
  }
  get isIndeterminateSelected() {
    return this.selected === -1;
  }
  get somehowSelected() {
    return Boolean(this.selected);
  }
  get isMatched() {
    return this.searchMatch === 1;
  }
  get isIndeterminateMatched() {
    return this.searchMatch === -1;
  }
  get isSomehowMatched() {
    return Boolean(this.searchMatch);
  }
  get fetched() {
    return Boolean(this.fetchHandle);
  }
  // All child, grandchild, great-grandchild, etc. nodes of a particular item.
  get descendants() {
    return this.getDescendants();
  }
  // Only immediate child nodes of a particular item.
  get children() {
    return this.getDescendants(this.depth + 1);
  }
  get showLoadingMore() {
    if (!this.parent) {
      return !this.selectro.isCompletelyFetched && this.selectro.items[this.selectro.items.length - 1] === this;
    } else {
      if (!this.parent.fetching) return false;
      return this.parent.children[this.parent.children.length - 1] === this;
    }
  }
  get parents() {
    const parents = [];
    let node = this.parent;
    while (node) {
      parents.push(node);
      node = node.parent;
    }
    return parents;
  }
  // For server-side searching, we create local items in the selected state
  // since they might not exist in the first page of results. This getter
  // returns the actual item from the main list if it exists, or falls back
  // to this local version.
  get realItem() {
    if (this.local) {
      return this.selectro.getItemByValue(this.value) || this;
    } else {
      return this;
    }
  }
  // ============================= ACTIONS ============================= //
  fetchData() {
    if (!this.fetchUrl || this.fetching || this.fetched && this.isCompletelyFetched && this.state.cacheFetchResponses)
      return;
    this.selectro.fetchData({
      url: this.fetchUrl,
      item: this,
      paginator: this
    });
  }
  setFetching(value) {
    this.fetching = Boolean(value);
    this.collapsed = false;
  }
  setFetchError(value) {
    this.fetchError = value;
  }
  deselect() {
    this.selected = 0;
  }
  // When scrolling to the selected item, expand all ancestors of the item
  // but do not run middlewares since this was not triggered by the user
  expandAncestors() {
    const ancestors = this.getAncestors();
    ancestors.reverse();
    ancestors.forEach((ancestor) => {
      toggleCollapsible(this.selectro, {
        item: ancestor,
        inSelectedList: false,
        collapse: false
      });
    });
  }
  collapse({ index, collapse = void 0 }) {
    const item = this;
    if (!item.branch) return;
    if (item.fetching) return;
    const inSelectedList = item.inSelectedList(index);
    const isCollapsed = item.isCollapsed(index);
    if (!inSelectedList && isCollapsed && !item.isCompletelyFetched)
      item.fetchData();
    runMiddlewares(collapseMiddlewares, this.selectro, {
      item,
      inSelectedList,
      collapse: collapse ?? !isCollapsed
    });
  }
  actionSetCurrentPage(value) {
    this.currentPage = value;
  }
  actionSetTotalPages(value) {
    this.totalPages = value;
  }
  actionSetNextPages(value) {
    this.nextPage = value;
  }
  setFetchHandle(fetchHandle) {
    this.fetchHandle = fetchHandle;
  }
  // TODO: Replace all instances of === 1/-1 with calls to methods above.
  // TODO: If any items have fetchUrl set but fetched unset (or selectro.cacheFetchResponses = false), then any searching must happen server side (or all unfetched items must be fetched).
  // TODO: Paged fetching (perhaps last item says `page x of y`) and if x < y we keep fetching when scrolled into view
  // TODO: Scroll seek placeholder https://virtuoso.dev/scroll-seek-placeholders
  // TODO: Make it so that selecting an item calls the normalize middlewares, but *only* calls it a single time (since normalization can select other items, etc.)
};
class RecentItem extends Item$2 {
  constructor(props) {
    super(props);
    this.depth = props.depth ?? 1;
    this.parent = void 0;
    this.branch = props.branch ?? false;
  }
  addToSearchIndex() {
  }
}
function optionsToList({ selectro, data, depth = 0, rootNode }) {
  const { list } = parseObject({
    selectro,
    list: [],
    data,
    depth,
    parent: rootNode
  });
  return list;
}
function parseObject({
  selectro,
  list,
  data = [],
  depth = 0,
  parent,
  localItem = false
}) {
  return (data == null ? void 0 : data.reduce) ? data.reduce(
    (acc, node) => {
      const item = {};
      const children = node.children;
      delete node.children;
      node.value = normalizeValue(node.value);
      const meta = node.meta || {};
      Object.entries(meta).forEach(([key, value]) => {
        if (key === "css_class") {
          node.class = value;
          delete node[key];
        } else {
          node[key] = value;
        }
        node[key] = value;
      });
      delete node.meta;
      item.depth = depth;
      const special = node.$ || {};
      Object.entries(special).forEach(([key, value]) => {
        item[key] = value;
      });
      delete node.$;
      if (localItem) {
        item.local = true;
      }
      if (children || node.fetchUrl) item.branch = true;
      if (!children && node.fetchUrl) item.collapsed = true;
      if (parent) item.parent = parent;
      item.selectro = selectro;
      item.data = node;
      const observableItem = new Item$2(item);
      list.push(observableItem);
      if (children && children.length > 0) {
        const childDepth = depth + 1;
        const parent2 = observableItem;
        const subList = parseObject({
          selectro,
          list,
          data: children,
          depth: childDepth,
          parent: parent2,
          localItem
        });
        list = subList.list;
      }
      return { list, depth };
    },
    { list, depth }
  ) : [];
}
function idleCallback(fn, timeout) {
  return process.env.NODE_ENV !== "test" ? requestIdleCallback(fn, { timeout }) : fn();
}
const getTemplate = (template, defaultTemplate2) => {
  if (!template && !defaultTemplate2) {
    Sentry.captureMessage(
      "No template or default template provided to getTemplate"
    );
    return null;
  }
  if (!template && !defaultTemplate2) return null;
  const type = typeof template;
  const isMemo = (template == null ? void 0 : template.$$typeof) === Symbol.for("react.memo");
  if (type === "function" || isMemo) return template;
  if (type === "string") {
    const resolvedTemplate = resolveWindowAttachedFunction(
      template,
      "Templates"
    );
    if (resolvedTemplate) return resolvedTemplate;
  }
  if (defaultTemplate2) return defaultTemplate2;
};
const TemplateResolution = ({
  template,
  defaultTemplate: defaultTemplate2,
  ...props
}) => {
  const controller = useController(SelectroController);
  if (!defaultTemplate2 && !template) return null;
  const Template = getTemplate(template, defaultTemplate2);
  const templateProps = { ...props, state: controller.state };
  if (typeof Template === "function" || (Template == null ? void 0 : Template.$$typeof) !== Symbol.for("react.memo")) {
    return Template({ ...templateProps, dontUseThisController: controller });
  }
  return /* @__PURE__ */ React.createElement(Template, { ...templateProps, dontUseThisController: controller });
};
const TemplateResolution$1 = ApplicationView(TemplateResolution);
const ClearAll = () => {
  const controller = useController(SelectroController);
  const { state } = controller;
  const [showModal, setShowModal] = useState(false);
  const clearConfirmationTemplate = state.templates.clearConfirmation ? getTemplate(state.templates.clearConfirmation, void 0) : void 0;
  const modalRef = useCallback((node) => {
    if (node) {
      node.addEventListener("aha-modal:closed", () => {
        setShowModal(false);
      });
    }
  }, []);
  function handleClick() {
    var _a;
    controller.clearSelectedItems();
    if (controller.usesCustomSearch || state.allowCreateNew) {
      controller.clearSelected();
    }
    if (document.activeElement && document.activeElement.classList.contains("SelectroV2__clear-all")) {
      const searchInput = (_a = controller.elementRef) == null ? void 0 : _a.querySelector(
        ":scope .SelectroV2__search-input"
      );
      if (searchInput && "focus" in searchInput) {
        searchInput.focus();
      }
    }
  }
  function toggleConfirmation() {
    setShowModal(!showModal);
  }
  function confirmationClearAll() {
    handleClick();
    toggleConfirmation();
  }
  const confirmationModal = clearConfirmationTemplate ? /* @__PURE__ */ React.createElement("aha-modal", { ref: modalRef, open: showModal ? true : null }, /* @__PURE__ */ React.createElement(TemplateResolution$1, { template: state.templates.clearConfirmation }), /* @__PURE__ */ React.createElement("aha-modal-footer", null, /* @__PURE__ */ React.createElement("aha-button", { slot: "secondary_actions", onClick: toggleConfirmation }, "Cancel"), /* @__PURE__ */ React.createElement("aha-button", { kind: "danger", onClick: confirmationClearAll }, "Continue"))) : null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: classcat({
        "SelectroV2__clear-all": true
      }),
      "data-testid": "clear-all",
      onClick: clearConfirmationTemplate ? toggleConfirmation : handleClick
    },
    state.text.clearSelection ?? "Clear selection"
  ), confirmationModal);
};
const ClearAll$1 = ApplicationView(ClearAll);
let ActionBar$2 = class ActionBar {
  // Link back to main selectro state.
  constructor(selectro) {
    __publicField(this, "type", "ActionBar");
    __publicField(this, "_active", 0);
    // Which item within the ActionBar is currently active.
    __publicField(this, "_numChildren", 0);
    // Number of direct child elements within the ActionBar.
    __publicField(this, "persistent", true);
    // Keeps on-screen, even when searching.
    __publicField(this, "isSelectable", true);
    // Clicking/key presses will register.
    __publicField(this, "children", []);
    __publicField(this, "visible", false);
    // Whether the ActionBar is visible or not.
    __publicField(this, "selectro");
    __publicField(this, "isVisible", (children) => {
      return Boolean(children.filter((c) => Boolean(c)).length);
    });
    // The children are cached and only redrawn in the following scenarios:
    // 1. When the headers change.
    // 2 When we open/close the drawer to make sure the clearAll button is always in-sync
    // 3. Any time the redrawSelectedList is called.
    __publicField(this, "redrawChildren", () => {
      const items = Array.isArray(this.selectro.state.headers) ? this.selectro.state.headers.slice(0) : [];
      if (this.showsClearAll(items)) {
        items.unshift(/* @__PURE__ */ React.createElement(ClearAll$1, null));
      } else {
        items.unshift(null);
      }
      this.children = items;
      this.visible = this.isVisible(items);
    });
    this.selectro = selectro;
  }
  get active() {
    return this._active;
  }
  set active(value) {
    this._active = value;
  }
  showsClearAll(items) {
    return (
      // By default, we only want to show this if there are items selected and
      // the clearAll button is enabled.
      this.selectro.state.showClearAllButton && (items.length || this.showsClearAllGeneric || this.showsClearAllForSingleType)
    );
  }
  // Engineers can choose if they want to display the clear all button when in single type mode
  // This is useful when the user should be able to unselect the item
  get showsClearAllForSingleType() {
    return this.selectro.selected.length > 0 && (this.selectro.state.type === "single" || this.selectro.state.type === "toggleSingle") && this.selectro.state.isSingleTypeUnselectable;
  }
  // We don't render the selectedList when on single mode, this checks if we
  // should show the clear all button for all the other types.
  get showsClearAllGeneric() {
    return this.selectro.state.memoizedSelectedList.length > 0;
  }
  get numChildren() {
    return this._numChildren;
  }
  set numChildren(value) {
    const max = value - 1;
    if (this.active > max || this.selectro.hoveredIndex !== 0) {
      this.active = max;
    }
    this._numChildren = value;
  }
  next() {
    if (this.active < this.numChildren - 1) {
      this.active += 1;
      return true;
    }
    return false;
  }
  previous() {
    if (this.active > 0) {
      this.active -= 1;
      return true;
    }
    return false;
  }
};
function fetchAnotherPage(controller) {
  if (controller.canFetch && !controller.state.fetching && !controller.isCompletelyFetched) {
    controller.fetchData({
      url: `${controller.state.fetchUrl}`,
      paginator: controller,
      // We don't want to replace the results that are already in the list when loading more results.
      replace: false,
      searchParam: controller.state.fetchSearchParam,
      searchQuery: controller.state.searchQuery
    });
  }
}
const retryableFetch = fetchRetry(window.fetch);
class FetchHandle {
  constructor(props) {
    __publicField(this, "url");
    __publicField(this, "item");
    __publicField(this, "replace", true);
    __publicField(this, "resultsBatch", []);
    __publicField(this, "selectro");
    __publicField(this, "paginator");
    __publicField(this, "searchParam");
    __publicField(this, "searchQuery");
    __publicField(this, "dontAutoPaginate", false);
    var _a;
    Object.entries(props).forEach(([k, v]) => {
      this[k] = v;
    });
    this.selectro = props.selectro;
    this.url = props.url ?? "";
    if (this.url === "" && !((_a = this.selectro) == null ? void 0 : _a.hasFetchFunction))
      throw new Error("FetchHandle must have a url set or a functions.fetch.");
    this.paginator = this.item || this.selectro;
    if (this.paginator) {
      this.paginator.setFetchHandle(this);
    } else {
      throw new Error(
        "FetchHandle must have either an item or selectro property set."
      );
    }
  }
  updateCurrentPage(obj) {
    var _a, _b;
    if (typeof ((_a = obj == null ? void 0 : obj.pages) == null ? void 0 : _a.current) !== "undefined") {
      (_b = this.paginator) == null ? void 0 : _b.actionSetCurrentPage(
        this.dontAutoPaginate ? 1 : parseInt(obj.pages.current, 10)
      );
    } else {
      const message = "JSON response should have a `{pages: {current: [value]} }` set.";
      console.warn(message);
      throw new Error(message);
    }
  }
  getNextPageUrl(searchParams) {
    searchParams.set(
      "page",
      this.dontAutoPaginate ? 1 : this.paginator.currentPage + 1
    );
    if (this.selectro.state.usesServerSearch && this.searchParam && this.searchQuery) {
      searchParams.set(this.searchParam, this.searchQuery);
    }
    return searchParams;
  }
  resetFetchedPages() {
    this.paginator.actionSetCurrentPage(0);
    this.paginator.actionSetTotalPages(0);
  }
  fullUrl() {
    const fullUrl = /^http/.test(this.url) ? new URL(this.url) : new URL(this.url, window.location.origin);
    const searchParams = new URLSearchParams(fullUrl.searchParams);
    fullUrl.search = this.getNextPageUrl(searchParams);
    return fullUrl;
  }
  fetchId() {
    if (this.selectro.hasFetchFunction) {
      return [this.selectro.state.uuid, "fetch_function"].join("-");
    }
    return [this.selectro.state.uuid, this.fullUrl()].join("-");
  }
  async fetchData() {
    const key = this.fetchId();
    if (!this.selectro.usesCustomSearch && this.selectro.fetchedUrlMap.get(key))
      return;
    this.selectro.fetchQueue.push(async () => {
      var _a, _b, _c;
      const measureFnPerformance = measurePerformance({
        name: `fetchData: ${key}`,
        group: true
      });
      this.paginator.setFetching(true);
      this.paginator.setFetchError(false);
      let data;
      let error;
      let fetchError;
      try {
        if (this.selectro.hasFetchFunction && this.selectro.state.functions.fetch) {
          data = await ((_a = this.selectro.state.functions) == null ? void 0 : _a.fetch({
            searchParam: this.searchQuery,
            paginator: {
              currentPage: this.paginator.currentPage,
              totalPages: this.paginator.totalPages,
              nextPage: this.paginator.nextPage
            },
            state: this.selectro.state
          }));
        } else {
          const url = this.fullUrl();
          if (this.selectro.state.usesServerSearch && this.searchQuery) {
            const searchParams = new URLSearchParams(url.searchParams);
            if (searchParams.get("page") === "1") {
              this.selectro.fetchQueue.end();
            }
          }
          data = await retryableFetch(`${url}`, {
            headers: { "Content-Type": this.selectro.state.fetchContentType },
            retries: 3,
            retryDelay: function(attempt) {
              return Math.pow(2, attempt) * 1e3;
            },
            signal: this.selectro.abortCtr.signal
          }).then((res) => {
            if (!res.ok) {
              fetchError = true;
            }
            return res.json();
          });
        }
        if (fetchError) {
          this.paginator.setFetchError(true);
        } else {
          if (((_b = data.pages) == null ? void 0 : _b.current) || ((_c = data.pages) == null ? void 0 : _c.total)) {
            this.updateCurrentPage(data);
            this.paginator.actionSetTotalPages(parseInt(data.pages.total, 10));
          } else {
            this.paginator.actionSetCurrentPage(1);
            this.paginator.actionSetTotalPages(1);
          }
          const measureAppendPerf = measurePerformance({
            name: "Appending to list"
          });
          if (this.selectro.state.callbacks.fetchTransform) {
            data = this.selectro.state.callbacks.fetchTransform({
              state: this.selectro.state,
              controller: this.selectro,
              data
            });
          }
          this.generateItems(data.options || data.children || data);
          measureAppendPerf();
          if (!this.selectro.state.hasBeenScrolledToFirstSelected) {
            this.selectro.redrawSelectedList();
          }
          this.selectro.normalizeItems();
          this.selectro.showSearchResults();
        }
      } catch (err) {
        if (!fetchError) {
          captureException(err);
        }
        this.paginator.setFetchError(true);
      }
      this.paginator.setFetching(false);
      if (this.paginator instanceof SelectroController && this.paginator.setFetchingFromEndReached)
        this.paginator.setFetchingFromEndReached(false);
      measureFnPerformance();
      return {
        error,
        fetchedUrlMapKey: key
      };
    });
    this.selectro.fetchedUrlMap.set(key, true);
  }
  generateItems(itemArray) {
    this.selectro.buildItemsFromOptions({
      nodes: itemArray,
      root: this.item,
      replace: this.replace
    });
  }
}
class RecentsControllerError extends Error {
}
class RecentsController {
  constructor(options, selectroController) {
    __publicField(this, "STORAGE_KEY", "selectro-recent");
    __publicField(this, "DEFAULT_COUNT", 3);
    __publicField(this, "uuid");
    __publicField(this, "count");
    __publicField(this, "flattenNested");
    __publicField(this, "fetchUrl");
    __publicField(this, "fetchUrlValueParam");
    __publicField(this, "items", []);
    __publicField(this, "isFetching", false);
    __publicField(this, "selectroController");
    this.uuid = options.uuid;
    this.count = options.count || this.DEFAULT_COUNT;
    this.flattenNested = options.flattenNested || false;
    this.fetchUrl = options.fetchUrl;
    this.fetchUrlValueParam = options.fetchUrlValueParam;
    this.selectroController = selectroController;
    void this.fetchRecentItems();
  }
  readLocalStorage() {
    const selectroStorage = localStorage.getItem(this.STORAGE_KEY);
    if (selectroStorage) {
      return JSON.parse(selectroStorage);
    }
    return {};
  }
  parseRecentValues() {
    const storage = this.readLocalStorage();
    const recentValues = storage[this.uuid] || [];
    if (this.flattenNested) {
      return recentValues.map((value) => value.split("/").at(-1));
    }
    return recentValues;
  }
  async fetchRecentItems() {
    if (!(this.fetchUrl && this.fetchUrlValueParam)) {
      throw new RecentsControllerError(
        "Missing fetchUrl or fetchUrlValueParam"
      );
    }
    const recentValues = this.parseRecentValues();
    if (!recentValues.length) return;
    const queryParams = recentValues.map((value) => `${this.fetchUrlValueParam}[]=${encodeURIComponent(value)}`).join("&");
    const url = `${this.fetchUrl}${this.fetchUrl.includes("?") ? "&" : "?"}${queryParams}`;
    this.isFetching = true;
    try {
      const response = await retryableFetch(url, {
        headers: { "Content-Type": "application/json" },
        retries: 3,
        retryDelay: (attempt) => Math.pow(2, attempt) * 1e3
      });
      if (!response.ok) {
        throw new Error("Failed to fetch recent items");
      }
      const data = await response.json();
      const options = data.options.map(
        (item) => ({
          ...item,
          ...item.data,
          ...item.meta
        })
      );
      this.items = options.map(
        (item) => new RecentItem({ data: item, selectro: this.selectroController })
      );
    } catch (error) {
      captureException(error);
      this.items = [];
    } finally {
      this.isFetching = false;
    }
  }
  setRecentItem(value) {
    const selectroStorage = this.readLocalStorage();
    const recentOptionsList = _.uniq(
      [value].concat(selectroStorage[this.uuid] || [])
    ).slice(0, this.count);
    selectroStorage[this.uuid] = recentOptionsList;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(selectroStorage));
  }
  getRecentItems() {
    const recentValues = this.items.filter(
      (item) => this.selectroController.selected.some((e) => item.data.value !== e.value)
    );
    if (!recentValues.length) return [];
    const result = [
      new RecentItem({
        data: {
          text: "Recents",
          value: "Recents",
          isHeading: true
        },
        selectable: false,
        selectro: this.selectroController,
        depth: 0,
        branch: true
      })
    ];
    if (this.isFetching) {
      result.push({ type: "loadingMessage" });
      return result;
    }
    result.push(...recentValues);
    return result;
  }
}
class CollapsibleStorageController {
  constructor(storageKey, selectroController) {
    __publicField(this, "SELECTRO_STORAGE_KEY", "selectro-collapsible");
    __publicField(this, "selectroController");
    __publicField(this, "storageKey");
    __publicField(this, "expandedList", {});
    this.selectroController = selectroController;
    this.storageKey = storageKey;
  }
  refreshFromStorage() {
    const parsedStorage = this.readStorage();
    this.expandedList = parsedStorage[this.storageKey] || {};
  }
  readStorage() {
    const collapsedStorage = sessionStorage.getItem(this.SELECTRO_STORAGE_KEY);
    if (collapsedStorage) {
      return JSON.parse(collapsedStorage) || {};
    }
    return {};
  }
  expandFromStorage() {
    this.refreshFromStorage();
    Object.entries(this.expandedList).forEach(([id, expanded]) => {
      const item = this.selectroController.getItemByValue(id);
      if (item) {
        toggleCollapsible(this.selectroController, {
          item,
          inSelectedList: false,
          collapse: !(expanded ?? false)
        });
      }
    });
  }
  setCollapsed(id, collapsed) {
    this.refreshFromStorage();
    if (collapsed) {
      delete this.expandedList[id];
    } else {
      this.expandedList[id] = !collapsed;
    }
    const storage = this.readStorage();
    storage[this.storageKey] = this.expandedList;
    try {
      sessionStorage.setItem(
        this.SELECTRO_STORAGE_KEY,
        JSON.stringify(storage)
      );
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
var SelectroEventType = /* @__PURE__ */ ((SelectroEventType2) => {
  SelectroEventType2["DropdownOpen"] = "selectro-v2:dropdown-open";
  SelectroEventType2["DropdownOpened"] = "selectro-v2:dropdown-opened";
  SelectroEventType2["DropdownClose"] = "selectro-v2:dropdown-close";
  SelectroEventType2["DropdownClosed"] = "selectro-v2:dropdown-closed";
  SelectroEventType2["Selected"] = "selectro-v2:selected";
  SelectroEventType2["SelectedChange"] = "selectro-v2:selected-change";
  SelectroEventType2["ClearSelectedItems"] = "selectro-v2:clear-selected-items";
  SelectroEventType2["ClearSelected"] = "selectro-v2:clear-selected";
  SelectroEventType2["ListHeightChanged"] = "selectro-v2:list-height-changed";
  return SelectroEventType2;
})(SelectroEventType || {});
var SelectroLoadingTypes = /* @__PURE__ */ ((SelectroLoadingTypes2) => {
  SelectroLoadingTypes2["SPINNER"] = "spinner";
  SelectroLoadingTypes2["LOADINGROW"] = "loading-row";
  return SelectroLoadingTypes2;
})(SelectroLoadingTypes || {});
class SelectroController extends ApplicationController {
  constructor() {
    super();
    // Ref to the outer selectro container element.
    __publicField(this, "elementRef", null);
    // Ref to the list container element.
    __publicField(this, "listContainerRef", null);
    // Ref to the search input element.
    __publicField(this, "searchFieldRef", null);
    // Ref to the popover element.
    __publicField(this, "popoverRef", null);
    // @ts-ignore
    __publicField(this, "fetchedUrlMap");
    // @ts-ignore
    __publicField(this, "fetchQueue");
    __publicField(this, "controllerPrototype");
    // A search-specific requestIdleCallback that may need to be cancelled.
    __publicField(this, "searchRIC");
    __publicField(this, "debouncedHandleSearch");
    __publicField(this, "searchIndex");
    __publicField(this, "fetchHandle");
    __publicField(this, "itemsUUIDMap", /* @__PURE__ */ new Map());
    __publicField(this, "abortCtr", new AbortController());
    __publicField(this, "recentsController", null);
    __publicField(this, "collapsibleStorageController", null);
    __publicField(this, "customActionSetters", {
      initialSelected: this.actionSetSelected,
      selected: this.actionSetSelected,
      items: this.actionSetItems,
      headers: this.actionSetHeader
    });
    __publicField(this, "actionSetCurrentPage", (val) => {
      this.state.currentPage = val;
    });
    __publicField(this, "actionSetTotalPages", (val) => {
      this.state.totalPages = val;
    });
    __publicField(this, "actionSetNextPage", (val) => {
      this.state.nextPage = val;
    });
    __publicField(this, "actionSetBreakMiddlewares", (val) => {
      this.state.breakMiddlewares = val;
    });
    __publicField(this, "actionSetSearchComplete", (val) => {
      this.state.searchComplete = val;
    });
    // Setter for search query value.
    // NOTE: When search query is any value other than null, it kicks off a fetch to pull in any remaining items from all fetchUrls.
    __publicField(this, "actionSetSearchQuery", (val) => {
      this.state.searchQuery = val === null ? "" : val;
      if (!this.searchIndex) return;
      this.debouncedHandleSearch(val);
    });
    // Create new local selected items, useful when rendering tags or customizable fields
    __publicField(this, "createNewSelectedItem", () => {
      const item = this.createLocalItem({
        text: this.state.searchQuery,
        value: this.state.searchQuery
      });
      this.selectItem({ item });
      this.actionSetSearchQuery("");
    });
    __publicField(this, "toggleDropdown", (event) => {
      const { newState } = event;
      newState === "open" ? this.afterDropdownOpens() : this.afterDropdownCloses();
    });
    __publicField(this, "setPopoverRef", (ref) => {
      this.popoverRef = ref;
    });
    __publicField(this, "setSearchFieldRef", (ref) => {
      this.searchFieldRef = ref;
    });
    __publicField(this, "setElementRef", (ref) => {
      this.elementRef = ref;
    });
    __publicField(this, "setListContainerRef", (ref) => {
      this.listContainerRef = ref;
    });
    this.controllerPrototype = Object.getPrototypeOf(this);
  }
  get initialState() {
    return {
      // ------- DEVELOPER SETTABLE VARIABLES ------- //
      name: void 0,
      singleHiddenInput: false,
      addBracketsAfterInputName: true,
      type: "single",
      collapsible: false,
      collapseByDefault: false,
      showSelectedList: void 0,
      hideSearchBar: false,
      searchFields: ["text"],
      searchTokenize: "forward",
      language: navigator.language,
      usesServerSearch: false,
      searchDebounce: 350,
      fetchUrl: void 0,
      fetchSearchParam: void 0,
      fetchContentType: "text/javascript;charset=UTF-8",
      maxFetchTries: 3,
      cacheFetchResponses: true,
      numConcurrentFetches: 10,
      deferFetch: true,
      controlled: false,
      callbacks: {},
      templates: {},
      functions: {},
      text: {},
      custom: {},
      includeDataInSelectedItems: true,
      showClearAllButton: true,
      isSingleTypeUnselectable: false,
      defaultTagsColor: void 0,
      showResultsCounter: false,
      coverTrigger: true,
      disabled: false,
      matchTriggerWidth: false,
      containerFullWidth: true,
      noneSelectedPrimaryText: false,
      appendFetchOptionsToExistingParent: false,
      branchesSelectable: true,
      allowCreateNew: false,
      headers: [],
      headerVertical: false,
      loadingIndicatorType: "spinner",
      showSelectedInSearch: true,
      customSearchUsesBuildFromOptions: false,
      sortByCurrentParentId: "",
      collapsibleStorageUuid: void 0,
      // ------- INTERNAL STATE VARIABLES ------- //
      // ---------------------------------------- //
      open: false,
      // Array of items. This forms the basis of all computed lists that are displayed to the user.
      _items: [],
      // Index of item that is selected.
      _hoveredIndex: 0,
      previousHoveredIndex: 0,
      // Map of pre-selected values, typically shown within a <DropdownTrigger> component. Follows form of:
      //    {
      //      [Item.value]: {
      //        status: [1/0/-1],  // Selected status (1=selected, 0=not selected, -1=pseudo selected)
      //        item: [Item]
      //      }
      //    }
      // where the status is 1 (selected), 0 (not selected), or -1 (indeterminate selected).
      // NOTE: This is a list of selected values passed in as a prop. The items in this list may or may not yet
      // exist within the `items` array (for example, when progressively fetching records, a selected item may only
      // appear in the `items` after the 4th of 6 pages).
      selectedState: /* @__PURE__ */ new Map(),
      // Map of items matched by searching. Follows form of:
      //    {
      //      [Item.value]: {
      //        value: [1/0/-1],  // Matched status (1=matched, 0=not matched, -1=pseudo matched)
      //      }
      //    }
      matchedState: /* @__PURE__ */ new Map(),
      lastChildrenSelectedList: /* @__PURE__ */ new Map(),
      lastChildrenMainList: /* @__PURE__ */ new Map(),
      // The current and total number of pages of items that exist. Should be specified within the JSON of the fetched data.
      totalPages: 0,
      // Total number of "pages" of results available via ajax fetch
      currentPage: 0,
      // The most current "page" of those results that we've fetched via ajax.
      nextPage: 0,
      // Keep track of whether list has been scrolled to the first selected item.
      hasBeenScrolledToFirstSelected: false,
      // When using arrow up/down to navigate the list, the mouse may be hovered on one item but the arrow up/down keys may
      // have caused the list to scroll, which in turn means that the mouse is now hovering over a different item than it
      // initially was over. Setting `pointerLock` to true when navigating via the keyboard prevents the scrolling of the
      // list (and resultant new item that the mouse is over) from triggering an update to the `hoveredIndex`.
      pointerLock: false,
      // Variable that is set to true when the user enters a search query. Variable is set/unset in the searching middleware.
      // NOTE: Ideally we would not need this variable, just using `Boolean(this.state.searchQuery)` instead. However if this is done,
      // then "no results found" is briefly displayed on the page when the user is initially searching (since returning search
      // results can take a few microseconds to complete) which makes the UI jump a bit in a jarring way.
      searchComplete: false,
      // Array of items that were in a selected state before any additional changes were made.
      // NOTE: Used to display the selected list. Selected list is NOT the current selected state, rather the last selected state when selectro was opened.
      // This is done to prevent UI from jumping around as more items are selected/unselected.
      memoizedSelectedList: [],
      // Whether the selectro is currently fetching data from a URL.
      fetching: void 0,
      // Whether the selectro is currently fetching data from a URL.
      scrollTouched: false,
      // Whether the selectro is currently fetching data when the list is scrolled to the bottom.
      fetchingFromEndReached: false,
      // Whether the selectro encountered an error when fetching data.
      fetchError: void 0,
      // A reference to actionBar state.
      actionBar: void 0,
      // Items which will be placed inside the ActionBar component. Can be DOM nodes, React components, or strings.
      // NOTE: This is a potential security risk, values for this should only be set by developers, never by customers.
      // Temporary space to store information (selected/collapsed status) etc. Useful when running callbacks and you need to
      // know the difference between the previous selected/collapsed status and the current one.
      previousState: {},
      // Internal value of the search query used to match against the `searchFields`.
      // Accessed by searchQuery() getter/setter.
      searchQuery: "",
      // A search-specific requestIdleCallback that may need to be cancelled.
      searchRIC: void 0,
      // Middlewares typically run until the complete stack of middleware functions (be it search, select, etc.) have run to completion.
      // Sometimes this is not desirable (ex. no need to run a search on '' as it will return everything). Setting `breakMiddleware = true`
      // will break any middleware out of its current run and return from a specific point. Typically, will not need to be modified directly.
      breakMiddlewares: false,
      uuid: "selectro",
      // Whether the value has been touched by the user.
      // Useful to check if the value has change or not.
      valueWasTouched: false,
      // Full height of the selectro list.
      _listHeight: 0
    };
  }
  async initialize(props = {}) {
    this.state.actionBar = new ActionBar$2(this);
    this.searchIndex = this.createSearchIndex();
    this.setValuesFromProps(props);
    const availableTypesForServerSearch = [
      "single",
      "toggleSingle",
      "multiple",
      "tree",
      "treeSingle"
    ];
    if (this.state.usesServerSearch && !availableTypesForServerSearch.includes(this.state.type)) {
      throw new Error(
        `The "usesServerSearch" option can only be used with a selectro type of ${availableTypesForServerSearch.join(
          ", "
        )}.`
      );
    }
    if (this.state.collapsible && !this.isTree) {
      throw new Error(
        'The "collapsible" option can only be used with a selectro type of "tree".'
      );
    }
    this.state.showSelectedList = this.state.showSelectedList ?? !this.isSingleSelect;
    this.createFetchQueue();
    this.initialFetch();
    this.debouncedHandleSearch = debounce(
      this.handleSearch,
      this.state.searchDebounce,
      {
        leading: true
      }
    );
    if (props.recents) {
      this.recentsController = new RecentsController(props.recents, this);
    }
    if (props.collapsibleStorageKey) {
      this.collapsibleStorageController = new CollapsibleStorageController(
        props.collapsibleStorageKey,
        this
      );
    }
  }
  changeProps(newProps, oldProps) {
    setTimeout(() => {
      Object.keys(newProps).forEach((key) => {
        if (key === "initialSelected") return;
        if (
          // Callbacks and templates should always be updated since they may contain references to a parent's local state.
          key === "callbacks" || key === "templates" || JSON.stringify(oldProps[key]) !== JSON.stringify(newProps[key])
        ) {
          this.setValuesFromProps({ [key]: newProps[key] });
        }
      });
    });
  }
  setValuesFromProps(props) {
    Object.entries(props).forEach(([key, value]) => {
      if (this.customActionSetters[key]) return;
      const descriptor = Object.getOwnPropertyDescriptor(
        this.controllerPrototype,
        key
      );
      if (typeof (descriptor == null ? void 0 : descriptor.set) !== "function") {
        this.state[key] = value;
      }
    });
    Object.entries(props).forEach(([key, value]) => {
      if (this.customActionSetters[key]) {
        this.customActionSetters[key](value);
      } else {
        const descriptor = Object.getOwnPropertyDescriptor(
          this.controllerPrototype,
          key
        );
        if (typeof (descriptor == null ? void 0 : descriptor.set) === "function") {
          this[key] = value;
        }
      }
    });
  }
  // Sometimes you want to force selectro to re-fetch items. This is the method you call to do that.
  clearCachedItems() {
    this.state._items = [];
    this.clearItemsUUIDMap();
    if (this.fetchHandle) {
      this.fetchHandle.resetFetchedPages();
      this.fetchHandle = void 0;
    }
    this.fetchedUrlMap.clear();
  }
  createFetchQueue() {
    this.fetchQueue = queue({
      autostart: true,
      concurrency: this.state.numConcurrentFetches
    });
    const endFn = () => {
      this.abortCtr.abort(
        "FetchQueue emptied, cancelling all in-progress fetches."
      );
      this.abortCtr = new AbortController();
      this.initialScrollToSelected();
    };
    this.fetchQueue.on("end", endFn);
    this.fetchedUrlMap = /* @__PURE__ */ new Map();
  }
  normalizeItems() {
    runMiddlewares(normalizeMiddlewares, this, {});
  }
  initialFetch() {
    if (this.canFetch && !this.state.deferFetch)
      this.fetchData({ url: this.state.fetchUrl });
  }
  setFetchHandle(fetchHandle) {
    this.fetchHandle = fetchHandle;
  }
  fetchData({
    url,
    item,
    replace,
    paginator,
    searchParam,
    searchQuery,
    dontAutoPaginate
  }) {
    if (!url && !this.hasFetchFunction) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "Attempted to fetch data without a URL or fetch function available"
        );
      }
      return;
    }
    const handle = new FetchHandle({
      url,
      item,
      replace,
      paginator,
      searchParam,
      searchQuery,
      selectro: this,
      dontAutoPaginate
    });
    handle.fetchData();
  }
  createSearchIndex() {
    if (!this.state.searchFields || !this.state.searchFields.length) {
      console.error(new Error("Must have an array of searchFields defined."));
      return false;
    }
    const searchIndex = new FlexSearch.Index({
      preset: "match",
      tokenize: this.state.searchTokenize,
      resolution: 3
    });
    searchIndex.matches = [];
    return searchIndex;
  }
  // Re-generate the search index. Should not be necessary in most circumstances, unless deleting items from selectro.
  reindexSearch() {
    let tempSearchIndex = this.createSearchIndex();
    this.items.forEach((item) => {
      item.addToSearchIndex();
    });
    this.searchIndex = tempSearchIndex;
    tempSearchIndex = void 0;
    this.showSearchResults();
  }
  // ============================= COMPUTED ============================= //
  get formInputName() {
    if (!this.state.name) return void 0;
    if (this.isSingleSelect || this.state.singleHiddenInput) {
      return this.state.name;
    } else if (/\[\]$/.test(this.state.name)) {
      return this.state.name;
    } else if (this.state.addBracketsAfterInputName) {
      return `${this.state.name}[]`;
    } else {
      return `${this.state.name}`;
    }
  }
  get hoveredIndex() {
    return this.state._hoveredIndex;
  }
  set hoveredIndex(value) {
    this.state.previousHoveredIndex = this.hoveredIndex;
    this.state._hoveredIndex = value;
  }
  get items() {
    return this.state._items;
  }
  set items(value) {
    this.buildItemsFromOptions({ nodes: value, replace: true });
  }
  getItemByValue(value) {
    return this.state._items.find((item) => item.value === value);
  }
  // A map of keys from an item's uuid which references the item itself. Generally used when getting search matches.
  generateItemsUUIDMap(items) {
    for (let i = 0; i < items.length; i++) {
      this.itemsUUIDMap.set(items[i].uuid, items[i]);
    }
  }
  clearItemsUUIDMap() {
    this.itemsUUIDMap = /* @__PURE__ */ new Map();
  }
  // Returns only the values of selected items (where selected === 1).
  get value() {
    const items = this.selectedItems;
    if (this.isSingleSelect) {
      if (!items.length) return void 0;
      return items[0].value;
    } else {
      return items.map((item) => item.value);
    }
  }
  // Handle setting a value directly on the selected property. Should be an `undefined`, or an array, or a single item, but can handle Set/Map as well.
  actionSetSelected(items) {
    items = toArray(items);
    this.state.selectedState.clear();
    this.normalizeSelectedValues(items).forEach((selectedItem) => {
      var _a;
      let item = selectedItem;
      if (this.usesCustomSearch) {
        item = this.createLocalItem(
          selectedItem,
          ((_a = selectedItem.children) == null ? void 0 : _a.length) > 0
        );
      }
      const selectedItems = Array.isArray(item) ? item : [item];
      selectedItems.forEach((item2) => {
        this.state.selectedState.set(item2.value, {
          status: 1,
          item: item2
        });
      });
    });
    this.normalizeItems();
    this.triggerEvent({
      event: "selectro-v2:selected-change"
      /* SelectedChange */
    });
  }
  actionSetItems(value) {
    if (this.usesCustomSearch && !this.state.customSearchUsesBuildFromOptions)
      return;
    this.buildItemsFromOptions({
      nodes: toArray(value),
      replace: true
    });
  }
  actionSetHeader(value) {
    var _a;
    if (value == null) return;
    if (!Array.isArray(value)) value = [value];
    this.state.headers = value;
    (_a = this.state.actionBar) == null ? void 0 : _a.redrawChildren();
  }
  actionDeleteFromSelectedState(value) {
    this.state.selectedState.delete(value);
  }
  actionAddToSelectedState(value, data) {
    this.state.selectedState.set(value, data);
  }
  // An array of "raw" selected items (plain JS objects, not proxies).
  get selected() {
    return this.selectedItems.map(({ data, text: text2, value, ...other }) => {
      if (this.state.includeDataInSelectedItems) {
        let selectedItem = { text: text2, value };
        if (data) {
          selectedItem = { ...selectedItem, ...data };
        } else {
          Object.entries(other).forEach(([key, value2]) => {
            selectedItem[key] = value2;
          });
        }
        return selectedItem;
      }
      return {
        text: text2,
        value,
        data
      };
    });
  }
  get firstSelectedItem() {
    return Array.from(this.state.selectedState)[0];
  }
  // Whether the selectro is a "single" select selectro. True if it is, false if it allows for selection of multiple values.
  get isSingleSelect() {
    return /single/i.test(this.state.type);
  }
  get isTree() {
    return /tree/i.test(this.state.type);
  }
  // Checks if the selectro list itself (and only the top-level list) and all its pages are completely fetched.
  get isCompletelyFetched() {
    if (!this.canFetch) return true;
    if (this.state.fetching) return false;
    if (typeof this.state.currentPage !== "undefined" && typeof this.state.totalPages !== "undefined" && this.state.currentPage >= this.state.totalPages)
      return true;
    return false;
  }
  get isFetchable() {
    return this.canFetch && !this.state.fetching && !this.isCompletelyFetched;
  }
  // Checks to see if both the list, and all items within the list, are completely fetched.
  get everythingIsFetched() {
    return this.isCompletelyFetched && this.items.every((item) => item.isCompletelyFetched);
  }
  // Checks to see if the list, or any of the items in the list, are currently fetching new data.
  get anythingIsFetching() {
    return this.items.some((item) => item.fetching) || this.state.fetching || false;
  }
  // Fetch every possible fetchUrl. Calling this function will fetch any additional pages of the main list, as well as any child,
  // grandchild, great-grandchild, etc. items which may have a fetchUrl.
  // WARNING: This can result in dozens of fetch calls, so we queue them, to avoid overloading the server.
  fetchEverything() {
    if (this.everythingIsFetched) return;
    if (this.isFetchable) {
      this.fetchData({ url: this.state.fetchUrl, paginator: this });
    }
    this.items.forEach((item) => {
      if (item.isFetchable) item.fetchData();
    });
  }
  get hasValidSearchQuery() {
    return this.state.searchQuery !== "" && this.state.searchQuery !== null && this.state.searchQuery !== void 0;
  }
  handleSearch(val) {
    if (this.usesCustomSearch && val !== null) {
      this.state.currentPage = 0;
      this.state.totalPages = 0;
      this.state.scrollTouched = false;
      this.state._items = [];
      this.clearItemsUUIDMap();
      this.fetchData({
        url: this.state.fetchUrl,
        // this.usesCustomSearch is already checking for fetchUrl
        replace: true,
        searchParam: this.state.fetchSearchParam,
        searchQuery: val,
        dontAutoPaginate: true
      });
    }
    if (this.searchRIC) window.cancelIdleCallback(this.searchRIC);
    this.searchRIC = idleCallback(
      () => {
        this.showSearchResults();
        this.searchRIC = void 0;
      },
      {
        timeout: 100
      }
    );
  }
  get currentPage() {
    return this.state.currentPage;
  }
  get totalPages() {
    return this.state.totalPages;
  }
  get nextPage() {
    return this.state.nextPage;
  }
  actionSetActiveBarActive(active) {
    if (!this.state.actionBar) return;
    this.state.actionBar.active = active;
  }
  // Getter for regex escaped search query.
  get regexSearchQuery() {
    let q = escapeRegex(this.state.searchQuery);
    q = q[0] === "\\" ? q : `\\b${q}`;
    return new RegExp(`(${q})`, "igu");
  }
  // *ORDERED* items where searchMatch is either 1 or -1.
  get searchMatchAndIndeterminateItems() {
    return this.state.searchComplete && !this.usesCustomSearch ? this.items.filter((n) => n.searchMatch || n.persistent) : this.items;
  }
  // *ORDERED* items where searchMatch is *ONLY* 1.
  get searchMatchItems() {
    return this.state.searchComplete ? this.searchMatchAndIndeterminateItems.filter((n) => n.searchMatch === 1) : [];
  }
  // *ORDERED* list of items where searchMatch is either 1/-1 and the item is collapsed or hidden by being a child of a collapsed item.
  get collapsedSearchMatchAndIndeterminateItems() {
    return this.searchMatchAndIndeterminateItems.filter((n) => !n.hiddenBy);
  }
  // *ORDERED* list of items where selected is *EITHER* 1 or -1.
  get selectedAndIndeterminateItems() {
    if (this.usesCustomSearch) {
      return this.selectedItems;
    }
    return this.items.filter((item) => item.selected);
  }
  get selectedItems() {
    return Array.from(this.state.selectedState).filter(([, { status }]) => status === 1).map(([, { item }]) => item).sort((a, b) => {
      var _a, _b, _c, _d, _e, _f;
      const aIsCurrentProject = ((_b = (_a = a.parent) == null ? void 0 : _a.data) == null ? void 0 : _b.isCurrentProject) || false;
      const bIsCurrentProject = ((_d = (_c = b.parent) == null ? void 0 : _c.data) == null ? void 0 : _d.isCurrentProject) || false;
      if (aIsCurrentProject && !bIsCurrentProject) return -1;
      if (!aIsCurrentProject && bIsCurrentProject) return 1;
      const parentNameA = ((_e = a.parent) == null ? void 0 : _e.text) || "";
      const parentNameB = ((_f = b.parent) == null ? void 0 : _f.text) || "";
      if (parentNameA !== parentNameB) {
        return -parentNameA.localeCompare(parentNameB);
      }
      return (a.text || "").localeCompare(b.text || "");
    });
  }
  // Selected items to be shown in the <DropdownTrigger> component.
  // NOTE: Returned in order of selection, rather than order the item appears in the list.
  // This way if you select item B, C, A see [B, C, A] in the dropdown trigger, rather than [A, B, C] which is the natural order of the items.
  get dropdownTriggerItems() {
    return this.selectedItems;
  }
  // Items which are selected AND which are not collapsed.
  // NOTE: When searching, show ALL items, including those that have been collapsed.
  // NOTE: Used when generating the "selected list", not the "main list".
  get collapsedSelectedItems() {
    if (this.state.searchComplete) {
      return this.selectedAndIndeterminateItems;
    } else {
      return this.selectedAndIndeterminateItems.filter(
        (item) => !item.hiddenBySelected
      );
    }
  }
  // The "top" list of items (the "selected list", only appears when there are selected items).
  get selectedList() {
    return this.state.showSelectedList ? this.state.memoizedSelectedList : [];
  }
  // The "bottom" list of items (the "main list", not the "selected list").
  get mainList() {
    return this.state.searchComplete ? this.searchMatchAndIndeterminateItems : this.collapsedSearchMatchAndIndeterminateItems;
  }
  get recentsWithoutSelected() {
    if (!this.recentsController) return [];
    const recents = this.recentsController.getRecentItems();
    return recents;
  }
  // The combined selected list and non-selected list.
  // NOTE: This is the "real" list the user will interact with.
  // @ts-ignore
  get list() {
    var _a, _b;
    const list = [];
    if ((_a = this.state.actionBar) == null ? void 0 : _a.visible) {
      list.push(this.state.actionBar);
    }
    if (this.mainList.length) {
      if (this.selectedList.length) {
        for (const item of this.selectedList.slice(0)) {
          list.push(item);
        }
      }
      const hasRecentsPositionedInItems = this.mainList.find(
        (item) => item.type === "recents"
      );
      if (!hasRecentsPositionedInItems && !this.state.searchComplete) {
        list.push(...this.recentsWithoutSelected);
      }
      for (const item of this.mainList) {
        if (item.type === "recents") {
          list.push(...this.recentsWithoutSelected);
        } else {
          if (item.type === "divider" && ((_b = list.at(-1)) == null ? void 0 : _b.type) === "divider") {
            continue;
          }
          list.push(item);
        }
      }
      if (this.state.loadingIndicatorType === "loading-row" && this.anythingIsFetching) ;
      else if (this.usesCustomSearch && !this.state.fetchingFromEndReached && this.anythingIsFetching) {
        list.push({ type: "loadingMessage" });
      }
    } else {
      if (!this.everythingIsFetched) {
        list.push({ type: "loadingMessage" });
      } else {
        list.push({
          type: "noResults",
          isSelectable: this.state.allowCreateNew,
          disabled: !this.state.allowCreateNew
        });
      }
    }
    return list;
  }
  // This set the internal value of open and also runs any side effects that are associated with the open state.
  actionToggleDropdown(newOpenValue) {
    if (this.state.disabled) return;
    newOpenValue ? this.beforeDropdownOpens() : this.beforeDropdownCloses();
    this.state.open = newOpenValue;
  }
  // ============================= ACTIONS ============================= //
  buildItemsFromOptions({
    nodes,
    root = void 0,
    replace = false
  }) {
    const perf = measurePerformance({ name: "clone nodes", group: true });
    nodes = cloneDeep(nodes);
    perf();
    if (this.usesCustomSearch && this.state.appendFetchOptionsToExistingParent && this.items.length > 0) {
      const processNode = (node, nodeRoot = root) => {
        if (node.children) {
          const parentItem = this.items.find(
            (item) => {
              var _a;
              return ((_a = item == null ? void 0 : item.data) == null ? void 0 : _a.value) === node.value && (item == null ? void 0 : item.branch);
            }
          );
          if (parentItem) {
            const isDeeplyNested = node.children.some((child) => child.children);
            if (!isDeeplyNested) {
              this._buildItems({
                nodes: node.children,
                root: parentItem,
                replace
              });
            } else {
              node.children.forEach((node2) => processNode(node2, parentItem));
            }
          } else {
            this._buildItems({ nodes: [node], root: nodeRoot, replace });
          }
        } else {
          this._buildItems({ nodes: [node], root: nodeRoot, replace });
        }
      };
      nodes.forEach((node) => processNode(node, root));
    } else {
      this._buildItems({ nodes, root, replace });
    }
  }
  // If there is a root node, then append/replace nodes starting from that root.
  // If no root is specified, then any appending or replacing nodes will take place on the entire list.
  // This is an internal function, if you want to build items from options use buildItemsFromOptions
  _buildItems({ nodes, root, replace }) {
    const rootDepth = 0;
    const newItems = optionsToList({
      selectro: this,
      data: nodes,
      depth: rootDepth,
      rootNode: root
    });
    function updateItemDepth(newItems2, initialDepth) {
      return newItems2.slice(0).map((item) => {
        item.depth = item.depth + initialDepth + 1;
        return item;
      });
    }
    if (root) {
      const rootIdx = this.items.indexOf(root);
      if (rootIdx === -1) {
        return console.error(
          new Error(
            `Root node with matching UUID not found. Could not append new items.`
          )
        );
      }
      const itemsWithDepth = updateItemDepth(newItems, root.depth);
      if (replace) {
        let numChildNodes = 0;
        for (let i = rootIdx + 1, len = this.items.length; i < len; i++) {
          const item = this.items[i];
          if (item.depth > root.depth) {
            numChildNodes += 1;
          } else {
            break;
          }
        }
        this.patchExistingList(rootIdx + 1, numChildNodes, itemsWithDepth);
      } else {
        let childOffset = 0;
        const items = this.items.slice(rootIdx + 1);
        for (let i = 0, len = items.length; i < len; i++) {
          const item = items[i];
          if (item.depth <= root.depth) break;
          childOffset += 1;
        }
        this.patchExistingList(rootIdx + 1 + childOffset, 0, itemsWithDepth);
      }
    } else {
      if (replace) {
        this.state._items = newItems;
      } else {
        newItems.forEach((item) => this.state._items.push(item));
      }
    }
    this.generateItemsUUIDMap(raw(newItems));
    if (this.state.callbacks.afterItemsAdded) {
      this.state.callbacks.afterItemsAdded({
        state: this.state,
        controller: this
      });
    }
  }
  // Add fetched items to a specific place within the existing list.
  // NOTE: Uses slice/push vs. concat because concat is thousands of times slower with large lists.
  // https://dev.to/uilicious/javascript-array-push-is-945x-faster-than-array-concat-1oki#:~:text=concat%20performs%20at%200.40%20ops,is%20945x%20faster%20than%20concat%20!
  patchExistingList(index, numberToReplace, newItems) {
    const perf = measurePerformance({ name: "patchExistingList", group: true });
    const firstHalf = this.items.slice(0, index);
    const secondHalf = this.items.slice(index + numberToReplace);
    newItems.forEach((item) => firstHalf.push(item));
    secondHalf.forEach((item) => firstHalf.push(item));
    this.state._items = firstHalf;
    perf();
  }
  // Update the hoveredIndex.
  // NOTE: Set `pointerLock` to "true" if hoverIndex is NOT changed via mouse/pointer.
  // TODO: Test pointerLock with touchscreen devices
  // NOTE: Set `redrawSelectedList` to "true" if you want to force the list to redraw (typically to show new selected items).
  //       This will cause a complete repaint of the list, which could potentially change the item your mouse is
  //       hovered over ... plan accordingly!
  setHoveredIndex({ index, pointerLock = false, redrawSelectedList: redrawSelectedList2 = false }) {
    this.hoveredIndex = index;
    this.setPointerLock(pointerLock);
    if (redrawSelectedList2) this.redrawSelectedList();
  }
  // Mobx action to set pointerLock. When set to `true` mouse movement over a different item does not cause that item to
  // become the "hovered" item. When set to `false` moving the mouse over a different item *will* cause that item to become
  // the "hovered" item.
  setPointerLock(pointerLock) {
    this.state.pointerLock = Boolean(pointerLock);
  }
  // Select a particular item.
  selectItem({ item }) {
    this.state.valueWasTouched = true;
    if (!item.updatesSearch) {
      runMiddlewares(selectMiddlewares, this, { item });
      this.triggerEvent({ event: "selectro-v2:selected", data: { item } });
      if (this.isSingleSelect && !item.updatesSearch) {
        this.actionToggleDropdown(false);
      }
    } else {
      this.actionSetSearchQuery(item.value);
    }
  }
  // Common functionality shared between clearSelectedItems and clearSelected methods.
  clearSelectedCommon(event) {
    this.redrawSelectedList();
    this.state.valueWasTouched = true;
    const callbackFn = getCallback(
      this.state.callbacks.clearAll
    );
    if (callbackFn)
      callbackFn({
        state: this.state,
        controller: this
      });
    this.triggerEvent({ event });
  }
  // Clear any items which are selected.
  // NOTE: This only operates on items which appear in the `items` array. Does not operate on items which may be preselected
  // but not yet fetched via ajax.
  clearSelectedItems() {
    this.items.forEach((item) => {
      item.selected = 0;
    });
    this.clearSelectedCommon(
      "selectro-v2:clear-selected-items"
      /* ClearSelectedItems */
    );
  }
  // Clears ALL selected values (either values matching an item in the `items` list, or an item which has not yet been fetched).
  clearSelected() {
    this.state.selectedState.clear();
    this.clearSelectedCommon(
      "selectro-v2:clear-selected"
      /* ClearSelected */
    );
  }
  // Function to build selectro custom events.
  buildCustomEvent({
    event,
    controller,
    data = {}
  }) {
    return new CustomEvent(event, {
      detail: {
        element: this.elementRef,
        controller,
        data
      }
    });
  }
  // Fire a regular DOM event. Useful for allowing other non-react scripts to interact with selectro state changes.
  triggerEvent({ event, data = {} }) {
    if (this.elementRef) {
      const customEvent = this.buildCustomEvent({
        event,
        controller: this,
        data
      });
      this.elementRef.dispatchEvent(customEvent);
      document.dispatchEvent(customEvent);
    }
  }
  // Run search middlewares which finds matching items.
  showSearchResults() {
    runMiddlewares(searchMiddlewares, this, {});
  }
  // Redraw the selected list. Typically, the selected list is only redrawn under two circumstances:
  // 1) Selectro is inside a dropdown and a selection is made, the dropdown is closed, and the user re-opens
  //    the dropdown.
  // 2) User clicks on the "[n] selected" link at the bottom of the selectro area.
  redrawSelectedList() {
    var _a;
    if (!this.state.showSelectedList) {
      this.state.memoizedSelectedList = [];
      return;
    }
    const list = [];
    const divider = { type: "divider", disabled: true, persistent: true };
    const selectedItems = /* @__PURE__ */ new Set();
    if (this.collapsedSelectedItems.length) {
      this.collapsedSelectedItems.forEach((item) => {
        const realItem = this.usesCustomSearch ? item.realItem : item;
        if (realItem.parents) {
          realItem.parents.reverse().forEach((parent) => {
            selectedItems.add(parent.realItem);
          });
        }
        selectedItems.add(realItem);
      });
      selectedItems.forEach((selectedItem) => list.push(selectedItem));
      list.push(divider);
      this.state.memoizedSelectedList = list;
    } else {
      this.state.memoizedSelectedList = [];
    }
    (_a = this.state.actionBar) == null ? void 0 : _a.redrawChildren();
  }
  setFetching(value) {
    this.state.fetching = Boolean(value);
  }
  setFetchingFromEndReached(value) {
    this.state.fetchingFromEndReached = Boolean(value);
  }
  setFetchError(value) {
    this.state.fetchError = value;
  }
  // Scroll to an item with the passed id.
  scrollToItemWithValue(value) {
    this.state.hasBeenScrolledToFirstSelected = true;
    const index = this.list.findIndex((item) => {
      var _a;
      return ((_a = item == null ? void 0 : item.data) == null ? void 0 : _a.value) === value;
    });
    if (index > -1) {
      this.hoveredIndex = index;
      this.state.pointerLock = true;
    }
  }
  // Scroll to the first selected item, but only do it *ONCE*. Typically used when fetching from an external URL.
  // Returns true/false for test purposes.
  initialScrollToSelected() {
    var _a, _b;
    if (this.state.hasBeenScrolledToFirstSelected || !this.isSingleSelect)
      return;
    this.redrawSelectedList();
    this.state.hasBeenScrolledToFirstSelected = true;
    if (this.state.collapseByDefault) this.collapseAll();
    (_a = this.collapsibleStorageController) == null ? void 0 : _a.expandFromStorage();
    const selected = Array.from(this.state.selectedState)[0];
    if (selected) {
      (_b = this.getItemByValue(selected[0])) == null ? void 0 : _b.expandAncestors();
      this.scrollToItemWithValue(selected[0]);
    }
  }
  collapseAll() {
    const items = [...this.items];
    items.reverse();
    items.forEach((item) => {
      if (item.branch && !item.disableCollapse) {
        toggleCollapsible(this, {
          item,
          inSelectedList: false,
          collapse: true
        });
      }
    });
  }
  scrollToSelected() {
    const selected = Array.from(this.state.selectedState)[0];
    if (selected && this.isSingleSelect && this.items.length) {
      this.scrollToItemWithValue(selected[0]);
    }
  }
  // This could be redundant, but we want to make sure when explicitly
  // clearing the searchQuery we set it to null
  clearSearch() {
    this.actionSetSearchQuery(null);
  }
  // Interface to make work with existing selectro v1 usages.
  normalizeSelectedValues(items) {
    items = toArray(items);
    return items.map((item) => {
      if (Array.isArray(item)) {
        let [text2, value] = item;
        value = normalizeValue(value);
        return { text: text2, value };
      } else {
        const value = normalizeValue(item.value);
        return { ...item, value };
      }
    });
  }
  // Create a new instance of an Item
  createLocalItem(item, returnChildren = false) {
    const { list } = parseObject({
      selectro: this,
      list: [],
      data: [item],
      depth: 0,
      parent: void 0,
      localItem: true
    });
    return returnChildren ? list.filter((item2) => !item2.branch) : list[0];
  }
  // Whether the selectro uses a custom search function.
  // This is useful when querying with GraphQL or an external API
  get hasFetchFunction() {
    return this.state.functions.fetch && typeof this.state.functions.fetch === "function";
  }
  get canFetch() {
    return Boolean(this.state.fetchUrl) || this.hasFetchFunction;
  }
  // Whether the selectro uses a custom search: Server Search || Custom fetch function
  get usesCustomSearch() {
    return Boolean(
      this.state.usesServerSearch && this.state.fetchSearchParam && this.state.fetchUrl || this.hasFetchFunction
    );
  }
  /**
   * This function is used to call the select callback from other places.
   *
   *   We only call the select callback when calling selectro.selectItem,
   *   sometimes we want to call it from other places like when removing an
   *   item from a selectro used in react-in-place.
   */
  callSelectCallback(payload) {
    callback$2(this, payload);
  }
  fetchOnOpen() {
    if (this.canFetch && this.state.deferFetch && this.state.fetchUrl) {
      if (this.fetchHandle) return;
      if (this.usesCustomSearch) {
        this.fetchData({
          url: this.state.fetchUrl,
          searchParam: this.state.fetchSearchParam,
          searchQuery: this.state.searchQuery,
          replace: true
        });
      } else {
        this.fetchData({ url: this.state.fetchUrl });
      }
    } else if (this.state.showSelectedList) {
      this.redrawSelectedList();
    }
  }
  //  --------- Dropdown lifecycle methods ---------------
  // When the user triggers a dropdown open, we just trigger the native showPopover method.
  // One the popover is shown we trigger the afterDropdownOpens method.
  beforeDropdownOpens() {
    var _a;
    this.triggerEvent({
      event: "selectro-v2:dropdown-open"
      /* DropdownOpen */
    });
    if (typeof ((_a = this.popoverRef) == null ? void 0 : _a.showPopover) === "function") {
      this.popoverRef.showPopover();
    }
  }
  afterDropdownOpens() {
    var _a;
    this.fetchOnOpen();
    (_a = this.state.actionBar) == null ? void 0 : _a.redrawChildren();
    if (this.searchFieldRef) {
      const selected = this.firstSelectedItem;
      if (selected && this.isSingleSelect && this.state.showSelectedInSearch) {
        this.searchFieldRef.value = selected[1].item.text;
      }
      this.searchFieldRef.focus();
      this.searchFieldRef.select();
    }
    const callbackFn = getCallback(
      this.state.callbacks.shown
    );
    if (callbackFn) {
      callbackFn({ state: this.state, open: true, controller: this });
    }
    this.triggerEvent({
      event: "selectro-v2:dropdown-opened"
      /* DropdownOpened */
    });
  }
  // When closing the dropdown we set open variable to false and hide the popover in the same method.
  // We don't wait for the popover toggle event to close the dropdown, we do it manually.
  beforeDropdownCloses() {
    this.triggerEvent({
      event: "selectro-v2:dropdown-close"
      /* DropdownClose */
    });
    if (this.popoverRef && typeof this.popoverRef.hidePopover === "function") {
      this.popoverRef.hidePopover();
    }
  }
  afterDropdownCloses() {
    var _a;
    this.scrollToSelected();
    if (!this.state.cacheFetchResponses || this.usesCustomSearch && this.hasValidSearchQuery) {
      this.clearCachedItems();
      this.initialFetch();
    }
    this.clearSearch();
    const callbackFn = getCallback(
      this.state.callbacks.hidden
    );
    if (callbackFn) {
      callbackFn({ state: this.state, open: false, controller: this });
    }
    this.state.valueWasTouched = false;
    this.triggerEvent({
      event: "selectro-v2:dropdown-closed"
      /* DropdownClosed */
    });
    if (this.state.showSelectedList) {
      this.redrawSelectedList();
    }
    (_a = this.state.actionBar) == null ? void 0 : _a.redrawChildren();
  }
  setListHeight({ wrapperRef, listHeight }) {
    if (!this.listContainerRef) return;
    const totalHeight = Array.from(this.listContainerRef.children).reduce(
      (acc, node) => {
        if (node === wrapperRef.current) {
          acc += listHeight;
        } else {
          acc += node.offsetHeight;
        }
        return acc;
      },
      0
    );
    if (totalHeight) this.state._listHeight = totalHeight;
  }
  get serializedInputValue() {
    if (!this.elementRef || !this.state.name) return "";
    if (this.selected.length <= 0) {
      return `${encodeURIComponent(this.state.name)}=${encodeURIComponent("")}`;
    }
    return this.selected.map(
      (item) => `${encodeURIComponent(
        this.state.name
      )}=${encodeURIComponent(item.value)}`
    ).join("&");
  }
}
const defaultTriggerItemsTemplate = ({
  items,
  state,
  limit = 100
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, state.text.selectedStatic || `${state.text.preScript || ""}${Object.values(items).slice(0, limit).map((item) => item.text).join(", ")}`);
function defaultTemplate({
  items,
  state,
  limit = 100
}) {
  const inner = items.length === 0 ? /* @__PURE__ */ React.createElement(
    "span",
    {
      className: classcat({
        SelectroV2__none_selected_text: true,
        "SelectroV2__none_selected_text--primary-text": state.noneSelectedPrimaryText
      })
    },
    typeof state.text.noneSelected === "string" ? `${state.text.preScript || ""}${state.text.noneSelected}` : "None"
  ) : /* @__PURE__ */ React.createElement(
    TemplateResolution$1,
    {
      template: state.templates.triggerItems,
      defaultTemplate: defaultTriggerItemsTemplate,
      items,
      limit
    }
  );
  return /* @__PURE__ */ React.createElement("button", { type: "button", className: "selectro-trigger default" }, inner);
}
const DropdownTrigger = () => {
  const controller = useController(SelectroController);
  const { state } = controller;
  return /* @__PURE__ */ React.createElement(
    TemplateResolution$1,
    {
      template: state.templates.trigger,
      defaultTemplate,
      items: controller.dropdownTriggerItems
    }
  );
};
const DropdownTrigger$1 = ApplicationView(DropdownTrigger);
function clamp({ value, min, max }) {
  return Math.min(Math.max(value, min), max);
}
const FetchingProgressBar = () => {
  const controller = useController(SelectroController);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "SelectroV2__fetching-progress-bar",
      hidden: !controller.anythingIsFetching || !controller.items.length,
      "data-testid": "fetching-progress-bar"
    },
    /* @__PURE__ */ React.createElement("div", null)
  );
};
const FetchingProgressBar$1 = ApplicationView(FetchingProgressBar);
const text = (number) => `Results: ${number}`;
const CounterFilterResults = () => {
  const controller = useController(SelectroController);
  const { state } = controller;
  if (!controller.state.searchQuery) return null;
  const number = controller.searchMatchItems.length;
  if (!state.showResultsCounter) return null;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "SelectroV2__counter-number Selectro__counter-number--filtered",
      "data-testid": "counter-search-matches"
    },
    text(i18nNumber(number, state.language)),
    renderIf(controller.anythingIsFetching)(
      /* @__PURE__ */ React.createElement("aha-spinner", { style: { marginLeft: "1ch" } })
    )
  );
};
const CounterNumberFiltered = ApplicationView(CounterFilterResults);
const InfoBar = () => {
  return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__info-bar", "data-testid": "info-bar" }, /* @__PURE__ */ React.createElement(CounterNumberFiltered, null));
};
const HighlightText = ({ item, text: text2 }) => {
  const controller = useController(SelectroController);
  const { state } = controller;
  if (!state.searchComplete || !controller.state.searchQuery || item.searchMatch !== 1 || !text2)
    return text2;
  return text2.split(controller.regexSearchQuery).map((string, index) => {
    if (index % 2 === 0) {
      return string;
    } else {
      return /* @__PURE__ */ React.createElement("mark", { key: `highlight-${index}`, "data-testid": "highlight-text" }, string);
    }
  });
};
const HighlightText$1 = ApplicationView(HighlightText);
const CollapseArrow = ({ index, item, clickHandler }) => {
  const controller = useController(SelectroController);
  const { state } = controller;
  const isCollapsed = !state.searchComplete && item.isCollapsed(index);
  const isDisabled = state.searchComplete || item.disabled;
  const collapsible = state.collapsible && item.branch && !item.disableCollapse;
  let icon;
  if (!collapsible) {
    return null;
  } else if (item.fetching && state.loadingIndicatorType === SelectroLoadingTypes.SPINNER) {
    icon = /* @__PURE__ */ React.createElement("aha-spinner", { class: "SelectroV2__spinner", "data-testid": "spinner" });
  } else {
    icon = /* @__PURE__ */ React.createElement(
      "fa-icon",
      {
        class: classcat({
          "fa-solid": true,
          "arrow--right": isCollapsed,
          "fa-caret-right": isCollapsed,
          "arrow--down": !isCollapsed,
          "fa-caret-down": !isCollapsed
        }),
        "data-testid": "arrow"
      }
    );
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classcat({
        "SelectroV2__collapse-arrow": true,
        "SelectroV2__collapse-arrow--disabled": isDisabled,
        "SelectroV2__collapse-arrow--hidden": !collapsible
      }),
      "data-testid": "collapse-arrow",
      onClick: clickHandler,
      tabIndex: 0,
      "aria-disabled": isDisabled
    },
    icon
  );
};
const CollapseArrow$1 = ApplicationView(CollapseArrow);
const Checkbox = ({ item, disabled }) => {
  const { isSingleSelect } = useController(SelectroController);
  if (!item.isSelectable) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__checkbox" }, isSingleSelect && item.isSelected && /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-check tw-pt-05" }), !isSingleSelect && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "!tw-cursor-pointer",
      tabIndex: -1,
      type: "checkbox",
      checked: item.isSelected,
      readOnly: true,
      disabled,
      "data-indeterminate": item.isIndeterminateSelected ? "true" : void 0
    }
  )));
};
const Checkbox$1 = ApplicationView(Checkbox);
const Submenu = ({ item, tabIndex }) => {
  return null;
};
const DEBUGGING_LAYOUT = false;
const DefaultItemContentTemplate = ({ item }) => {
  return /* @__PURE__ */ React.createElement(HighlightText$1, { item, text: item.text });
};
const DefaultTemplate = ({ state, item, tabIndex }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    TemplateResolution$1,
    {
      template: state.templates.itemPrepend,
      item,
      tabIndex
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classcat({
        SelectroV2__text: true
      }),
      "data-testid": "item-default-template",
      tabIndex: item.disabled ? null : tabIndex
    },
    /* @__PURE__ */ React.createElement(
      TemplateResolution$1,
      {
        template: state.templates.itemContent,
        defaultTemplate: DefaultItemContentTemplate,
        item,
        tabIndex
      }
    )
  ), item.submenu ? /* @__PURE__ */ React.createElement(Submenu, { item, tabIndex }) : null, /* @__PURE__ */ React.createElement(
    TemplateResolution$1,
    {
      template: state.templates.itemPostpend,
      item,
      tabIndex
    }
  ));
};
const Item2 = ({ item, prevItem, index }) => {
  const controller = useController(SelectroController);
  const { state, props } = controller;
  function handleMouseMove() {
    if (!state.pointerLock && index !== controller.hoveredIndex) {
      controller.setHoveredIndex({ index });
    }
  }
  function handleClick(e) {
    if (typeof item.onClick === "function") item.onClick(e, item);
    if (e.defaultPrevented || item.disabled) return;
    if (!item.isSelectable) {
      if (state.collapsible && item.branch && !item.disableCollapse)
        handleCollapseArrowClick(e);
      return;
    }
    controller.selectItem({ item });
  }
  function handleFocus() {
    if (index === controller.hoveredIndex) return;
    controller.setHoveredIndex({ index, pointerLock: true });
  }
  function handleMouseDown(e) {
    const searchField = e.target.closest(".SelectroV2").querySelector(':scope .SelectroV2__search input[type="text"]');
    if (searchField) {
      e.preventDefault();
      if (document.activeElement !== searchField) searchField.focus();
    }
  }
  function handleCollapseArrowClick(e) {
    e.stopPropagation();
    if (item.fetching) return;
    item.collapse({ index });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-testid": "item",
      "data-depth": item.depth,
      className: classcat({
        SelectroV2__item: true,
        "SelectroV2__item--is-hovered": controller.hoveredIndex === index,
        "SelectroV2__item--is-disabled": item.disabled,
        "SelectroV2__item--is-not-selectable": !item.isSelectable,
        "SelectroV2__item--is-clickable": !item.disabled && state.collapsible && item.branch && !item.disableCollapse,
        "SelectroV2__item--is-branch": item.branch,
        "SelectroV2__item--is-top-level": item.depth === 0 && (prevItem == null ? void 0 : prevItem.type) !== "divider",
        "SelectroV2__item--is-selected": item.selected === 1 || item.inSelectedList(index),
        "SelectroV2__item--is-from-selected-list": item.inSelectedList(index),
        "SelectroV2__first-item": index === 0,
        "SelectroV2__item--centered": props.centeredItemContent,
        [`${item.data.class}`]: !!item.data.class
      }),
      style: {
        "--Selectro__item--depth": item.depth
      },
      disabled: item.disabled,
      "aria-disabled": item.disabled,
      "aria-selected": item.isSelected,
      onMouseMove: handleMouseMove,
      onFocusCapture: handleFocus,
      onClick: handleClick,
      onMouseDown: handleMouseDown
    },
    /* @__PURE__ */ React.createElement(
      CollapseArrow$1,
      {
        index,
        item,
        clickHandler: handleCollapseArrowClick
      }
    ),
    /* @__PURE__ */ React.createElement(Checkbox$1, { item, disabled: !item.isSelectable || item.disabled }),
    /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__item-template" }, /* @__PURE__ */ React.createElement(
      TemplateResolution$1,
      {
        defaultTemplate: DefaultTemplate,
        template: state.templates.item,
        index,
        item,
        tabIndex: 0
      }
    ))
  ), (item.fetching || DEBUGGING_LAYOUT) && controller.state.loadingIndicatorType === SelectroLoadingTypes.LOADINGROW && /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__item SelectroV2__loading-children" }, /* @__PURE__ */ React.createElement(
    "aha-loading-row",
    {
      rows: 1,
      columns: 1,
      "column-widths": "100%",
      "content-width": "100%"
    }
  )));
};
const Item$1 = ApplicationView(Item2);
function Divider() {
  return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__divider" }, /* @__PURE__ */ React.createElement("hr", null));
}
const LoadingMessage = ({ paused, text: text2 = "Loading…", className, loadingIndicatorType }) => {
  if (loadingIndicatorType === SelectroLoadingTypes.LOADINGROW) {
    return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(
      "aha-loading-row",
      {
        rows: 1,
        columns: 1,
        "column-widths": "100%",
        "content-width": "100%"
      }
    ));
  } else {
    return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement("span", { className: "tw-pr-1" }, /* @__PURE__ */ React.createElement("aha-spinner", { class: "SelectroV2__spinner", paused })), /* @__PURE__ */ React.createElement("span", { className: classcat({ "SelectroV2__fetch-error": paused }) }, text2));
  }
};
const LoadMore = ({
  item,
  depth
}) => {
  const parent = item && item.parent;
  const controller = useController(SelectroController);
  function manuallyFetch() {
    if (item.fetchError) {
      if (!item.fetching && item.fetchUrl) {
        item.setFetchError(false);
        controller.fetchData({
          url: item.fetchUrl,
          paginator: item,
          item: parent ? item : void 0,
          replace: false
        });
      }
    }
  }
  useEffect(() => {
    if (parent && !parent.fetching && !parent.isCompletelyFetched) {
      if (!parent.fetching && !parent.isCompletelyFetched) {
        fetchAnotherPage(parent);
      }
    }
  }, []);
  const descendants = parent ? parent.descendants : controller.items;
  const text2 = item.fetchError ? "Fetching failed, please try again." : descendants.length ? "Loading more…" : "Loading…";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "SelectroV2__item SelectroV2__loading-more",
      style: {
        paddingLeft: `calc(${depth} + 0.6em)`,
        cursor: item.fetchError ? "pointer" : void 0
      },
      onClick: manuallyFetch
    },
    /* @__PURE__ */ React.createElement(
      LoadingMessage,
      {
        paused: item.fetchError,
        text: text2,
        className: "SelectroV2__loading-message"
      }
    )
  );
};
const LoadMore$1 = ApplicationView(LoadMore);
const ActionBarChild = ({ index, child, childIdx }) => {
  var _a;
  const controller = useController(SelectroController);
  const { state } = controller;
  function activate() {
    controller.actionSetActiveBarActive(childIdx > -1 ? childIdx : 0);
  }
  function handleClick(e) {
    activate();
    if (e.currentTarget.firstElementChild)
      e.currentTarget.firstElementChild.click();
  }
  function createMarkup(value) {
    if (typeof value !== "string") return;
    return { __html: value };
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classcat({
        "SelectroV2__action-bar-child": child && true,
        "SelectroV2__action-bar-child--is-hovered": child && controller.hoveredIndex === index && ((_a = state.actionBar) == null ? void 0 : _a.active) === childIdx
      }),
      "data-index": child && childIdx,
      onMouseEnter: activate,
      onClick: handleClick,
      dangerouslySetInnerHTML: createMarkup(child)
    },
    renderIf(typeof child !== "string")(child)
  );
};
const ActionBarChild$1 = ApplicationView(ActionBarChild);
const ActionBar2 = ({ index }) => {
  var _a;
  const controller = useController(SelectroController);
  const { state } = controller;
  const elem = useRef(null);
  const setNumChildren = (target) => {
    if (!state.actionBar) return;
    state.actionBar.numChildren = target.querySelectorAll(
      ":scope .SelectroV2__action-bar-child"
    ).length;
  };
  useEffect(() => {
    if (!elem.current) return;
    const target = elem.current;
    setNumChildren(target);
    new MutationObserver(() => {
      setNumChildren(target);
    }).observe(target, { childList: true, subtree: true });
  }, [elem.current]);
  if (!((_a = state.actionBar) == null ? void 0 : _a.children.length)) return null;
  function handleHover(e) {
    if (controller.hoveredIndex === index) return;
    controller.setHoveredIndex({ index, pointerLock: e.type === "focus" });
  }
  let childIdx = -1;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: elem,
      className: classcat({
        "SelectroV2__action-bar": true,
        "SelectroV2__action-bar-vertical": state.headerVertical,
        "tw-hidden": state.fetching
      }),
      "data-testid": "action-bar",
      onMouseEnter: handleHover,
      onFocus: handleHover
    },
    state.actionBar.children.map((child, idx) => {
      if (child) childIdx += 1;
      return /* @__PURE__ */ React.createElement(
        ActionBarChild$1,
        {
          key: idx,
          index,
          child,
          childIdx
        }
      );
    })
  );
};
const ActionBar$1 = ApplicationView(ActionBar2);
const NoResults = ({ index }) => {
  const controller = useController(SelectroController);
  const { state } = controller;
  if (state.allowCreateNew && !state.selectedState.get(state.searchQuery) && state.searchQuery) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classcat({
          "SelectroV2__item SelectroV2__item--create-new": true,
          "SelectroV2__item--is-hovered": controller.hoveredIndex === index
        }),
        onClick: controller.createNewSelectedItem
      },
      'Create "',
      state.searchQuery,
      '"'
    );
  }
  return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__item SelectroV2__item--no-results" }, "No results");
};
const NoResults$1 = ApplicationView(NoResults);
function itemAndLoading({ item, itemComponent, depth = 0 }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, itemComponent, /* @__PURE__ */ React.createElement(LoadMore$1, { item, depth }));
}
function getDepth(depth) {
  if (depth == null) return void 0;
  return depth * 16;
}
const ListItem = ({
  index,
  list
}) => {
  const controller = useController(SelectroController);
  const { state } = controller;
  const item = list[index];
  const prevItem = list[index - 1];
  if (!item) return null;
  switch (item.type) {
    case "Item": {
      const depth = getDepth(item.depth);
      const itemComponent = /* @__PURE__ */ React.createElement(Item$1, { index, item, prevItem });
      if (item.isCompletelyFetched) {
        if (!controller.isCompletelyFetched && controller.items[controller.items.length - 1] === item)
          return itemAndLoading({ item, itemComponent, depth });
        return itemComponent;
      } else {
        if (!item.fetchError) return itemComponent;
        return itemAndLoading({ item, itemComponent, depth });
      }
    }
    case "ActionBar":
      return /* @__PURE__ */ React.createElement(ActionBar$1, { index });
    case "divider":
      return /* @__PURE__ */ React.createElement(Divider, null);
    case "loadMore":
      return /* @__PURE__ */ React.createElement(LoadMore$1, { item });
    case "noResults":
      return /* @__PURE__ */ React.createElement(
        TemplateResolution$1,
        {
          defaultTemplate: () => /* @__PURE__ */ React.createElement(NoResults$1, { index }),
          template: state.templates.noResults
        }
      );
    case "loadingMessage":
      return /* @__PURE__ */ React.createElement(
        LoadingMessage,
        {
          className: "SelectroV2__item tw-pb-2",
          loadingIndicatorType: controller.state.loadingIndicatorType
        }
      );
    case "heading":
      return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__item", "data-depth": 0 }, item.text);
    default:
      return null;
  }
};
const ListItem$1 = ApplicationView(ListItem);
const List = ({ forwardedRef: listRef }) => {
  var _a;
  const controller = useController(SelectroController);
  const { state, list } = controller;
  const wrapperRef = useRef(null);
  const listElem = (_a = wrapperRef.current) == null ? void 0 : _a.firstElementChild;
  const listHeightRef = useRef((listElem == null ? void 0 : listElem.scrollHeight) || 0);
  useEffect(() => {
    const watchMouseMovement = (e) => {
      if (e.movementX || e.movementY) {
        controller.setPointerLock(false);
      }
    };
    if (state.pointerLock) {
      document.addEventListener("mousemove", watchMouseMovement);
    } else {
      document.removeEventListener("mousemove", watchMouseMovement);
    }
    return () => {
      document.removeEventListener("mousemove", watchMouseMovement);
    };
  }, [controller, state.pointerLock]);
  useEffect(() => {
    if (listRef && listRef.current && wrapperRef.current) {
      const scroller = wrapperRef.current.querySelector(
        ":scope .SelectroV2__list"
      );
      if (scroller && scroller instanceof HTMLElement) {
        scroller.tabIndex = -1;
      }
    }
  }, [listRef, wrapperRef]);
  useEffect(() => {
    const moveStickyHeader = () => {
      var _a2, _b;
      const listElem2 = (_a2 = wrapperRef == null ? void 0 : wrapperRef.current) == null ? void 0 : _a2.querySelector(
        ":scope .SelectroV2__list"
      );
      if (listElem2) {
        const stickyElem = listElem2.querySelector(':scope [style*="sticky"]');
        if (stickyElem) {
          stickyElem.classList.toggle(
            "SelectroV2__non_sticky",
            !((_b = state.actionBar) == null ? void 0 : _b.visible)
          );
        }
        if (stickyElem && stickyElem instanceof HTMLElement && listElem2.firstElementChild !== stickyElem) {
          stickyElem.style.zIndex = "2";
          listElem2.insertAdjacentElement("afterbegin", stickyElem);
        }
      }
    };
    moveStickyHeader();
    const observer = new MutationObserver(moveStickyHeader);
    if (wrapperRef.current) {
      observer.observe(wrapperRef.current, {
        childList: true,
        subtree: true
      });
    }
    return () => observer.disconnect();
  }, [wrapperRef, state.actionBar]);
  function handleListHeightChange(newListHeight) {
    const resizeFn = () => {
      listHeightRef.current = newListHeight;
      controller.setListHeight({
        listHeight: listHeightRef.current,
        wrapperRef
      });
      controller.triggerEvent({
        event: SelectroEventType.ListHeightChanged,
        data: { listHeight: listHeightRef.current, wrapperRef }
      });
    };
    newListHeight > 0 ? resizeFn() : requestAnimationFrame(() => resizeFn());
  }
  const renderItem = (index) => {
    return /* @__PURE__ */ React.createElement(ListItem$1, { index, list });
  };
  function handleEndReached() {
    if (state.scrollTouched && !state.fetching && controller.items.length) {
      controller.setFetchingFromEndReached(true);
      fetchAnotherPage(controller);
    }
  }
  function listContent() {
    var _a2;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Virtuoso,
      {
        ref: listRef,
        topItemCount: ((_a2 = state.actionBar) == null ? void 0 : _a2.visible) ? 1 : 0,
        overscan: controller.usesCustomSearch ? 20 : 200,
        defaultItemHeight: 22,
        className: "SelectroV2__list",
        totalCount: list.length,
        totalListHeightChanged: handleListHeightChange,
        itemContent: renderItem,
        endReached: handleEndReached,
        isScrolling: (isScrolling) => {
          if (!isScrolling) return;
          if (!state.hasBeenScrolledToFirstSelected)
            state.hasBeenScrolledToFirstSelected = true;
          if (!state.scrollTouched) state.scrollTouched = true;
        },
        components: {
          Item: (props) => {
            const data = props["data-item-index"] === list.length - 1 ? { "data-last-item": true } : {};
            return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__list-item", ...props, ...data });
          }
          // EmptyPlaceholder: // NOTE: Unfortunately not able to use this option. The presense of a selected list will cause this not to be shown.
        }
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { ref: wrapperRef, className: "SelectroV2__body", "data-testid": "list" }, listContent()), /* @__PURE__ */ React.createElement(TemplateResolution$1, { template: state.templates.listAppend }));
};
const List$1 = ApplicationView(List);
const Search = () => {
  const controller = useController(SelectroController);
  const { state } = controller;
  const searchFieldRef = useRef(null);
  const handleChange = (e) => {
    controller.actionSetSearchQuery(e.target.value);
  };
  const handleClear = () => {
    var _a;
    controller.actionSetSearchQuery("");
    (_a = searchFieldRef == null ? void 0 : searchFieldRef.current) == null ? void 0 : _a.focus();
  };
  function handleBlur(e) {
    if (e.relatedTarget && e.relatedTarget.classList.contains("SelectroV2__list")) {
      e.currentTarget.focus();
    }
  }
  return /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__search", "data-testid": "search-field" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: (node) => {
        searchFieldRef.current = node;
        controller.setSearchFieldRef(node);
      },
      type: "text",
      onChange: handleChange,
      onBlur: handleBlur,
      placeholder: state.text.searchPlaceholder ?? "Search…",
      value: state.searchQuery,
      className: "SelectroV2__search-input",
      autoComplete: "off"
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__search_icon" }, state.searchQuery ? /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      onClick: handleClear,
      className: "SelectroV2__clear-button",
      hidden: !state.searchQuery
    },
    /* @__PURE__ */ React.createElement("i", { className: "SelectroV2__clear-icon fa-solid fa-times-circle" })
  ) : /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" })));
};
const Search$1 = ApplicationView(Search);
function updateHoveredIndex(controller, value) {
  controller.setHoveredIndex({ index: value, pointerLock: true });
}
function handlePageUpAndDown({
  event,
  controller,
  list
}) {
  const rows = Array.from(
    event.currentTarget.querySelectorAll(":scope [data-index]")
  );
  if (rows.length > 2) {
    const start = parseInt(rows[1].dataset.index, 10);
    const end = parseInt(rows[rows.length - 2].dataset.index, 10);
    const diff = event.key === "PageDown" ? end - start : start - end;
    const index = clamp({
      min: 0,
      value: controller.hoveredIndex + diff,
      max: list.length - 1
    });
    updateHoveredIndex(controller, index);
  }
}
const watchKeys = {
  ArrowUp: ({ event, controller, item }) => {
    if (!item) return;
    event.preventDefault();
    if (item.type === "ActionBar") {
      if (item.previous()) return;
    }
    if (controller.hoveredIndex > 0) {
      updateHoveredIndex(controller, controller.hoveredIndex - 1);
    }
  },
  ArrowDown: ({ event, controller, item, list }) => {
    if (!item) return;
    event.preventDefault();
    if (item.type === "ActionBar") {
      if (item.next()) return;
    }
    if (controller.hoveredIndex < list.length - 1) {
      updateHoveredIndex(controller, controller.hoveredIndex + 1);
    }
  },
  ArrowLeft: ({ controller, item }) => {
    if (!item) return;
    if (item.type === "ActionBar") {
      item.previous();
    } else if (!controller.state.searchComplete && controller.state.collapsible && item.branch) {
      item.collapse({ index: controller.hoveredIndex, collapse: true });
    }
  },
  ArrowRight: ({ controller, item }) => {
    if (!item) return;
    if (item.type === "ActionBar") {
      item.next();
    } else if (!controller.state.searchComplete && controller.state.collapsible && item.branch) {
      item.collapse({ index: controller.hoveredIndex, collapse: false });
    }
  },
  PageUp: ({ event, controller, list }) => {
    handlePageUpAndDown({ event, controller, list });
  },
  PageDown: ({ event, controller, list }) => {
    handlePageUpAndDown({ event, controller, list });
  },
  Home: ({ controller }) => {
    updateHoveredIndex(controller, 0);
  },
  End: ({ controller, list }) => {
    updateHoveredIndex(controller, list.length - 1);
  },
  Enter: ({
    event,
    controller,
    item
  }) => {
    var _a, _b;
    if (!item || item.disabled || !item.isSelectable) return;
    if (["BUTTON", "A", "AHA-BUTTON", "AHA-DROPDOWN", "AHA-TOOLTIP"].includes(
      (_a = event.target) == null ? void 0 : _a.tagName
    ))
      return;
    if (item.type === "ActionBar") {
      const node = (_b = controller.elementRef) == null ? void 0 : _b.querySelector(
        ":scope .SelectroV2__action-bar-child--is-hovered"
      );
      if (node && node instanceof HTMLElement && !node.hidden && // @ts-expect-error - disabled is not a standard attribute, but we use it in our components.
      !node.disabled) {
        node.click();
      }
    } else if (item.type === "clearAll") {
      controller.clearSelectedItems();
    } else if (item.type === "noResults") {
      controller.createNewSelectedItem();
    } else {
      event.stopPropagation();
      controller.selectItem({ item });
    }
  }
};
const Keybindings = () => {
  const controller = useController(SelectroController);
  const { state, list } = controller;
  const selectroRef = useRef(null);
  const listRef = useRef(null);
  function handleKeyDown(event) {
    if (!watchKeys[event.key]) return;
    const item = list[controller.hoveredIndex];
    watchKeys[event.key]({ event, controller, item, ref: selectroRef, list });
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      preventNextKey({
        key: "Enter",
        eventName: "keyup"
      });
    }
  }
  useEffect(() => {
    if (state.pointerLock && listRef.current) {
      listRef.current.scrollToIndex({
        index: controller.hoveredIndex,
        align: "center"
      });
    }
  }, [controller.hoveredIndex, state.pointerLock]);
  useEffect(() => {
    controller.setListContainerRef(selectroRef.current);
  });
  return /* @__PURE__ */ React.createElement("div", { ref: selectroRef, className: "SelectroV2", onKeyDown: handleKeyDown }, Boolean(!state.hideSearchBar) && /* @__PURE__ */ React.createElement(Search$1, null), /* @__PURE__ */ React.createElement(FetchingProgressBar$1, null), /* @__PURE__ */ React.createElement(List$1, { forwardedRef: listRef }), /* @__PURE__ */ React.createElement(InfoBar, null));
};
const Keybindings$1 = ApplicationView(Keybindings);
const NOT_ALLOWED_TAGS = ["a"];
const canTargetOpenDropdown = (target) => {
  if (!target) return false;
  const tag = target.tagName.toLowerCase();
  const notAllowedParent = target.closest(NOT_ALLOWED_TAGS.join(","));
  return !NOT_ALLOWED_TAGS.includes(tag) && !notAllowedParent;
};
const targetClosesDropdown = (target) => {
  if (!target) return false;
  const tag = target.tagName.toLowerCase();
  return NOT_ALLOWED_TAGS.includes(tag);
};
const Dropdown = ({ className, id, style }) => {
  const popoverRef = useRef(null);
  const containerRef = useRef(null);
  const controller = useController(SelectroController);
  const { state } = controller;
  const { refs, floatingStyles, placement, elements, update, isPositioned } = useFloating({
    open: state.open,
    placement: "bottom-start",
    strategy: "fixed",
    middleware: [
      autoPlacement({
        allowedPlacements: [
          "top-start",
          "bottom-start",
          "top-end",
          "bottom-end"
        ]
      }),
      offset(({ rects }) => {
        if (state.coverTrigger) {
          return -rects.reference.height;
        } else {
          return 0;
        }
      }),
      size({
        apply({ rects, elements: elements2 }) {
          Object.assign(elements2.floating.style, {
            // Always set the maxWidth to the width of the reference element.
            maxWidth: `${rects.reference.width}px`,
            ...state.matchTriggerWidth && {
              minWidth: `${rects.reference.width}px`
            }
          });
          if (state.coverTrigger && !state.custom.doNotMatchTriggerHeight) {
            const triggerHeight = `${rects.reference.height}px`;
            if (controller.searchFieldRef) {
              controller.searchFieldRef.style.setProperty(
                "--Selectro__input-height",
                triggerHeight
              );
            }
          }
        }
      })
    ]
  });
  const handleOpenChange = useCallback(
    (event) => {
      if (!canTargetOpenDropdown(event.target)) return;
      if (!state.open) {
        controller.actionToggleDropdown(true);
      } else {
        controller.actionToggleDropdown(false);
      }
    },
    [controller, state.open]
  );
  const handleClicksInsideDropdown = useCallback(
    (event) => {
      if (targetClosesDropdown(event.target)) {
        controller.actionToggleDropdown(false);
      }
    },
    [controller]
  );
  const handleTriggerKeyDown = useCallback(
    (e) => {
      switch (e.key) {
        case "Enter":
          e.preventDefault();
          e.stopPropagation();
          controller.actionToggleDropdown(true);
          preventNextKey({ key: "Enter", eventName: "keyup" });
          break;
      }
    },
    [controller]
  );
  const focusTrigger = useCallback(() => {
    var _a;
    if (containerRef) {
      const trigger = (_a = containerRef.current) == null ? void 0 : _a.querySelector(
        ":scope button.selectro-trigger"
      );
      if (trigger && trigger instanceof HTMLElement) {
        trigger.focus();
      }
    }
  }, []);
  const handleKeyDown = useCallback(
    (e) => {
      switch (e.key) {
        case "Escape":
          e.preventDefault();
          e.stopPropagation();
          controller.actionToggleDropdown(false);
          preventNextKey({ eventName: "keyup", key: "Escape" });
          focusTrigger();
          break;
      }
    },
    [controller, focusTrigger]
  );
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!state.open || !refs.reference.current || !refs.floating.current)
        return;
      if (!refs.reference.current.contains(
        event.target
      ) && !refs.floating.current.contains(event.target)) {
        controller.actionToggleDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs.floating, refs.reference, state.open, controller]);
  useEffect(() => {
    const popoverElement = popoverRef.current;
    popoverElement == null ? void 0 : popoverElement.addEventListener("toggle", controller.toggleDropdown);
    return () => {
      popoverElement == null ? void 0 : popoverElement.removeEventListener("toggle", controller.toggleDropdown);
    };
  }, [controller.toggleDropdown]);
  useEffect(() => {
    if (state.open && elements.reference && elements.floating) {
      return autoUpdate(elements.reference, elements.floating, update);
    }
  }, [state.open, elements.floating, elements.reference, update]);
  useEffect(() => {
    if (!containerRef.current) return;
    Object.defineProperty(containerRef.current, "selectro", {
      value: controller,
      configurable: true,
      enumerable: false
    });
    containerRef.current.dataset.selectro = "";
    containerRef.current.dataset.hasSelectroStore = "true";
  }, [controller]);
  useEffect(() => {
    if (!popoverRef.current) return;
    if (isPositioned) {
      restrictScroll.add(popoverRef.current);
    } else {
      restrictScroll.delete(popoverRef.current);
    }
    return () => {
      restrictScroll.delete(popoverRef.current);
    };
  }, [isPositioned]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style,
      id,
      ref: (node) => {
        containerRef.current = node;
        controller.setElementRef(node);
      },
      "data-testid": "selectrov2-container",
      className: classcat({
        SelectroV2__dropdown: true,
        "SelectroV2__dropdown--disabled": state.disabled,
        "SelectroV2__dropdown--full-width": state.containerFullWidth,
        "SelectroV2__dropdown--open": state.open && isPositioned,
        [className]: className
      })
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "SelectroV2__dropdown__trigger-container",
        ref: refs.setReference,
        onClick: handleOpenChange,
        onKeyDown: handleTriggerKeyDown
      },
      /* @__PURE__ */ React.createElement(TemplateResolution$1, { template: state.templates.triggerVerticalPrepend }),
      /* @__PURE__ */ React.createElement("div", { className: "SelectroV2__dropdown__trigger--content" }, /* @__PURE__ */ React.createElement(
        TemplateResolution$1,
        {
          template: state.templates.triggerHorizontalPrepend
        }
      ), /* @__PURE__ */ React.createElement(DropdownTrigger$1, null), /* @__PURE__ */ React.createElement(
        TemplateResolution$1,
        {
          template: state.templates.triggerHorizontalAppend
        }
      )),
      /* @__PURE__ */ React.createElement(TemplateResolution$1, { template: state.templates.triggerVerticalAppend })
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: (node) => {
          popoverRef.current = node;
          controller.setPopoverRef(node);
        },
        popover: "manual",
        className: "SelectroV2__dropdown__popover"
      },
      state.open && /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: refs.setFloating,
          style: {
            ...floatingStyles,
            height: state._listHeight,
            // We want to hide the dropdown when it's not positioned.
            visibility: isPositioned ? "visible" : "hidden"
          },
          "data-placement": placement.split("-")[0],
          onClick: handleClicksInsideDropdown,
          onKeyDown: handleKeyDown,
          className: "SelectroV2__dropdown__content-container"
        },
        /* @__PURE__ */ React.createElement(Keybindings$1, null)
      )
    )
  );
};
const Dropdown$1 = ApplicationView(Dropdown);
const FormInputs = () => {
  const controller = useController(SelectroController);
  const { state } = controller;
  if (!state.name) return null;
  const formInputValue = (item) => {
    var _a;
    if (state.custom.useTextInFormInput) {
      return item.text;
    } else {
      return ((_a = item.data) == null ? void 0 : _a.form_value) || item.value;
    }
  };
  if (state.singleHiddenInput && controller.selectedItems.length > 0) {
    const groupedValue = controller.selectedItems.map((item) => formInputValue(item)).join(",");
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "hidden",
        className: "SelectroV2__hidden-selected-input",
        name: controller.formInputName,
        value: groupedValue
      }
    );
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, controller.selectedItems.map((item) => {
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "hidden",
        className: "SelectroV2__hidden-selected-input",
        name: controller.formInputName,
        value: formInputValue(item),
        key: item.value
      }
    );
  }));
};
const FormInputs$1 = ApplicationView(FormInputs);
const SelectroV2 = () => {
  const controller = useController(SelectroController);
  const { className, id, style } = controller.props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Dropdown$1, { className, id, style }), /* @__PURE__ */ React.createElement(FormInputs$1, null));
};
const SelectroV2$1 = StartControllerScope(
  SelectroController,
  ApplicationView(SelectroV2)
);
const styles = "";
export {
  HighlightText$1 as HighlightText,
  SelectroController,
  SelectroEventType,
  TemplateResolution$1 as TemplateResolution,
  SelectroV2$1 as default,
  resolveWindowAttachedFunction
};
